export const languageGerman = {
    "formating": {
        "main": "Haupt-Anweisung",
        "jailbreak": "Jailbreak Anweisung",
        "chats": "Vergangene Chats",
        "lorebook": "Lore-Buch",
        "globalNote": "Globale Notiz",
        "authorNote": "Anmerkungen des Autors",
        "lastChat": "Letzter Chat",
        "description": "Charakterbeschreibung",
        "personaPrompt": "Anweisung zur Persona",
        "plain": "Einfache Anweisung",
        "memory": "Supa/HypaMemory",
        "postEverything": "End-Injected Prompts"
    },
    "errors": {
        "toomuchtoken": "Fehler: Die Mindestgröße für die Antwort der KI in Tokens, die Sie angegeben haben, übersteigt die maximale Kontextgröße des Modells",
        "unknownModel": "Fehler: Unbekanntes Modell ausgewählt",
        "httpError": "Fehler: Es ist ein Fehler bei der Anfrage aufgetreten:",
        "noData": "Die Datei scheint nicht gültig zu sein oder die Daten sind beschädigt.",
        "onlyOneChat": "Es muss mindestens ein Chat vorhanden sein",
        "alreadyCharInGroup": "Es gibt bereits einen Charakter mit dem selben Namen in der Gruppe",
        "noUserIcon": "Sie müssen zuerst Ihr Icon festlegen",
        "emptyText": "Der Text ist leer.",
        "wrongPassword": "Falsches Passwort",
        "networkFetch": "Dies passiert, wenn das Netzwerk instabil ist oder der Server ausgefallen ist.",
        "networkFetchWeb": "Dies kann ein CORS-Fehler sein. Dies geschieht nur bei Verwendung der Webversion aufgrund von Browserbeschränkungen. Versuchen Sie, die lokale Desktop-Version oder eine andere Version von Risuai zu verwenden.",
        "networkFetchPlain": "Dies kann ein einfacher Abruffehler sein. Versuchen Sie, die Option 'Erzwinge einfachen Abruf' in den Einstellungen zu deaktivieren.",
        "requestLogRemoved": "Dieses Anfrage-Protokoll wurde entfernt.",
        "requestLogRemovedDesc": "Dieses Anfrage-Protokoll wird entfernt, wenn der Client aktualisiert oder neu geladen wird.",
        "vertexAuthError": "Vertex AI-Authentifizierungsdetails fehlen.",
        "coldStorageWriteFailed": "Kaltlager-Schreibvorgang fehlgeschlagen. Ihre Chat-Daten wurden beibehalten.",
        "coldStorageVerifyFailed": "Kaltlager-Überprüfung fehlgeschlagen. Ihre Chat-Daten wurden beibehalten.",
        "coldStorageRestoreFailed": "Kaltlagerdaten konnten nicht geladen werden. Die Daten des betroffenen Charakters können dauerhaft verloren sein.",
        "coldStorageIncompleteBackupConfirm": (characterNames: string, unavailableCount: number, unresolvedCount: number) =>
            `Kaltlagerdaten für ${characterNames || "unbekannte Charaktere"} fehlen oder sind ungültig.${unresolvedCount > 0 ? ` ${unresolvedCount} Element(e) konnten keinem Charakter zugeordnet werden.` : ""}\n\nWenn Sie fortfahren, fehlen in dieser Sicherung ${unavailableCount} Kaltlagerelement(e). Die betroffenen Charakter- oder Chatdaten können daraus möglicherweise nicht wiederhergestellt werden.\n\nTrotzdem eine unvollständige Sicherung erstellen?`,
        "coldStorageIncompleteRestoreConfirm": (characterNames: string, unavailableCount: number, unresolvedCount: number) =>
            `Kaltlagerdaten für ${characterNames || "unbekannte Charaktere"} konnten nicht wiederhergestellt werden.${unresolvedCount > 0 ? ` ${unresolvedCount} Element(e) konnten keinem Charakter zugeordnet werden.` : ""}\n\nWenn Sie fortfahren, bleiben ${unavailableCount} Kaltlagerelement(e) nicht verfügbar. Die betroffenen Charakter- oder Chatdaten können dauerhaft verloren gehen.\n\nTrotzdem mit der unvollständigen Wiederherstellung fortfahren?`
    },
    "showHelp": "Hilfe anzeigen",
    "help": {
        "model": "Das Hauptmodell, das im Chat verwendet wird",
        "submodel": "Ein Hilfsmodell ist ein Modell, das zur Analyse von Emotionen und automatischen Vorschlägen usw. verwendet wird, um die die Konversation dynamischer zu gestalten. GPT-3.5 wird hier empfohlen.",
        "oaiapikey": "API-Schlüssel für OpenAI. Sie können sich unter platform.openai.com unter -> account -> api-keys einen API-Schlüssel erstellen",
        "mainprompt": "Die Option für den Hauptanstoß legt das Standardverhalten des Modells fest",
        "jailbreak": "Die Option für die Jailbreak Anweisung wird aktiviert, wenn der Jailbreak-Umschalter im Charakter eingeschaltet ist",
        "globalNote": "Eine Notiz, die das Modellverhalten stark beeinflusst, auch bekannt als UJB. Funktioniert bei allen Charakteren",
        "autoSuggest": "Anweisungen, die verwendet werden, um Optionen zur automatischen Vorschlagsgenerierung für Benutzerantworten zu generieren",
        "formatOrder": "Formatierungsreihenfolge der Anweisungen. Weiter unten vorkommende Blöcke wirken sich stärker auf das Modell aus",
        "forceUrl": "Wenn es nicht leer ist, wird die Anfrage an die eingegebene URL gesendet",
        "tempature": "Niedrigere Werte führen dazu, dass der Charakter den Anweisungen eng folgt, aber eher maschinenähnlicher reagiert.\nHöhere Werte führen zu kreativem Verhalten, aber die Antwort des Charakters kann leichter inkohärent werden.",
        "frequencyPenalty": "Höhere Werte verhindern die Verwendung von Wiederholungen vor allem in der Antwort, aber die Antwort des Charakters kann leichter inkohärent werden",
        "presensePenalty": "Höhere Werte verhindern die Verwendung von Wiederholungen im gesamten Kontext, aber die Antwort des Charakters kann leichter inkohärent werden",
        "sdProvider": "Anbieter für die Bildgenerierung",
        "msgSound": "Spielt einen Sound ab, wenn der Charakter antwortet",
        "charDesc": "Kurzbeschreibung des Charakters. Dies beeinflusst mittelgradig die Antwort des Charakters",
        "charFirstMessage": "Erste Nachricht des Charakters. Dies beeinflusst die Antwort des Charakters stark",
        "charNote": "Eine Notiz, die das Modellverhalten stark beeinflusst. Eingebettet in den aktuellen Charakter, auch bekannt als UJB",
        "toggleNsfw": "Aktiviert/deaktiviert Jailbreak Anweisung",
        "lorebook": "Ein Lore-Buch ist ein vom Benutzer erstelltes Wörterbuch für die KI. Die KI sieht es nur, wenn ein entsprechendes Trigger-Wort im Kontext vorkommt.",
        "loreName": "Name des Lore (Hat auf die Antwort der KI keine Auswirkung)",
        "loreActivationKey": "Wenn eines der Trigger-Wörter im Kontext vorkommt, wird das Lore aktiviert und der entsprechende Anweisungs-Kontext wird berücksichtigt. Trigger-Wörter werden durch Kommata getrennt.",
        "loreorder": "Wenn die Insert-Reihenfolge höher ist, wirkt sie sich stärker auf das Modell aus und wird weniger stark beeinträchtigt, wenn viele Lore aktiviert sind",
        "bias": "Bias ist ein Schlüssel-Wert Attribut, das die Wahrscheinlichkeit des Vorkommens bestimmter Ausdrücke ändert.\nDas Attribut kann Werte zwischen -100 und 100 annehmen. Ausdrücke mit höheren Werten werden häufiger auftreten, während solche mit niedrigeren Werten seltener auftreten werden.\nAchtung: Stellen Sie sicher, dass der korrekte Tokenizer eingestellt ist, andernfalls kann diese Funktion nicht ordnungsgemäß umgesetzt werden.",
        "emotion": "Die Option 'Emotion Images' zeigt ein Bild abhängig von der aktuellen Emotion des Charakters, die anhand seiner/ihrer Antwort analysiert wird. Sie müssen den Emotionsnamen als Wort eingeben (wie z.B. Freude, Glück, Angst usw). Die Emotion mit dem Namen **neutral** wird als Standardemotion verwendet, sofern sie vorhanden ist. Es müssen mindestens 3 Bilder vorhanden sein, damit die Emotionszuweisung ordnungsgemäß funktioniert.",
        "imggen": "Die Option 'Image Generation' generiert und zeigt ein Bild aus einem externen Programm an. Das Bild wird anhand des aktuellen Chats generiert, der durch die Bild-Anweisung analysiert wird.\n\nDie Bildgenerierung basiert auf konfigurierbaren Schlüsselwertargumenten, darunter:\n\n Der Schlüssel **'always'** gilt immer und ändert sich nicht. Der Schlüssel '**negative**' gilt immer negativ für die Bildgenerierung\n\nObjekte mit dem Wert eines anderen Schlüssels ändern sich entsprechend dem Namen des Schlüssels, während der Chat fortschreitet\n\nWenn ein Schlüssel ein Sonderzeichen am Anfang seines Namens enthält, bekommt dieser eine besondere Wirkung\n- Wenn der Schlüssel mit **|** beginnt, ändert sich der Wert des Schlüssels nicht\n- Wenn der Schlüssel mit **$** beginnt, ändert sich der Wert des Schlüssels höchstwahrscheinlich\n\nWenn das Bild zum ersten Mal generiert wird, können Sie es nur ändern, indem Sie 'Aktuelle Bilddatengenerierung' unten modifizieren",
        "regexScript": "RegEx-Skript ist ein benutzerdefiniertes Skript, das Zeichenfolgen,\n\ndie IN entsprechen, durch OUT ersetzt. Es gibt vier Optionstypen:\n\n- **Eingabe ändern** ändert die Eingabe des Benutzers\n\n- **Ausgabe ändern** ändert die Ausgabe des Charakters\n\n- **Anforderungsdaten ändern** ändert die aktuellen Chat-Daten beim Senden\n\n- **Anzeige ändern** ändert nur den Text bei der Anzeige, ohne Chat-Daten zu ändern\n\nIN muss ein RegEx ohne Flags und ohne Schrägstriche am Anfang und Ende sein.\n\nOUT ist eine Zeichenfolge, die Ersetzungsmuster enthalten kann. Dies sind die Muster:\n\n- $$\n\n    - fügt $ ein\n\n- $&\n\n    - fügt den übereinstimmenden Teilstring ein\n\n- $`\n\n    - fügt den Teil der Zeichenfolge ein, der dem übereinstimmenden Teilstring vorausgeht\n\n- $1\n\n    - fügt die erste übereinstimmende Gruppe ein. funktioniert mit anderen Nummern wie 2, 3...\n\n- $(name)\n\n    - fügt die benannte Gruppe ein\n\nWenn OUT mit **@@** beginnt, ersetzt es nicht die Zeichenfolge, sondern führt stattdessen eine spezielle Wirkung aus, wenn eine übereinstimmende Zeichenfolge gefunden wird\n\n- @@emo (Emotionsname)\n\n    - wenn der Charakter den Emotion Images Modus verwendet, wird (Emotionsname) als Emotion festgelegt und die Standardoption verhindert",
        "experimental": "Dies ist ein experimentelles Feature und könnte instabil sein",
        "oogaboogaURL": "Wenn Ihre WebUI nur eine ältere Version der API unterstützt, sollte Ihre URL in etwa so aussehen *https:.../run/textgen*\n\nWenn Ihre WebUI die neue Version der API unterstützt, sollte Ihre URL in etwa so aussehen *https://.../api/v1/generate* – und den API-Server als Host verwenden sowie --api als Argument hinzufügen",
        "exampleMessage": "Beispielgespräche, die die Ausgabe des Charakters beeinflussen. Es werden keine Tokens dauerhaft verwendet.\n\nBeispielformat von Gesprächen:\n\n```\n<START>\n{{user}}: hi\n{{char}}: hallo\n<START>\n{{user}}: hi\nHaruhi: hallo\n```\n\n```<START>``` markiert den Beginn eines neuen Gesprächs",
        "creatorQuotes": "Beachten Sie, dass diese Anmkerung oberhalb der ersten Nachricht angezeigt wird. Sie wird verwendet, um den Benutzer über diesen Charakter zu informieren. Diese Anmerkung wird nicht in die Anweisungen eingespielt und hat deshalb keine Auswirkung auf die Antwort der KI.",
        "systemPrompt": "Eine Anweisung, mit der die Haupt-Anweisung aus den Einstellungen ersetzt wird, sofern das Feld nicht leer ist",
        "chatNote": "Eine Notiz, die das Verhalten der KI stark beeinflusst. Diese Notiz wird in den aktuellen Chat eingebettet. Auch bekannt als Memory oder UJB.",
        "personality": "Eine kurze Beschreibung der Persönlichkeit des Charakters. \n\n**Es wird nicht empfohlen, diese Option dafür zu nutzen. Beschreiben Sie die Persönlichkeit stattdessen in der Charakterbeschreibung.**",
        "scenario": "Eine kurze Beschreibung des Szenarios des Charakters. \n\n**Es wird nicht empfohlen, diese Option zu nutzen. Beschreiben Sie das Szenario stattdessen in der Charakterbeschreibung.**",
        "utilityBot": "Wenn aktiviert, werden Haupt-Anweisung, Jailbreak und andere Anweisungen ignoriert. Wird für Bots verwendet, die für Hilfsprogramme erstellt wurden, nicht für Rollenspiele.",
        "loreSelective": "Wenn der selektive Modus aktiviert ist, müssen sowohl Trigger-Wort als auch auch das Co-Trigger-Wort übereinstimmen, um den Kontext zu aktivieren",
        "loreRandomActivation": "Wenn die Bedingung 'Wahrscheinlichkeit verwenden' aktiviert ist, wird der Kontext mit einer festgelegten Wahrscheinlichkeit, die durch 'Wahrscheinlichkeit' festgelegt wird, jedes Mal aktiviert, wenn eine Chat-Nachricht gesendet wird und die anderen Bedingungen der Überlieferung alle erfüllt sind",
        "additionalAssets": "Zusätzliche Assets, die in Ihrem Chat angezeigt werden sollen. \n\n - verwenden Sie `{{raw::<asset name>}}` um als Pfad zu verwenden.\n – verwenden Sie `{{image::<asset name>}}` um als Bild zu verwenden\n - verwenden Sie `{{video::<asset name>}}` um als Video zu verwenden\n – verwenden Sie `{{audio::<asset name>}}` um als Audio zu verwenden\n – es wird empfohlen, dies im HTML Backend einzufügen",
        "superMemory": "SupaMemory ermöglicht es Ihrem Charakter, sich mehr Informationen zu 'merken', indem der KI zusammengefasste Daten zugeführt werden.\n\nDas SupaMemory-Modell ist ein Modell, das die Zusammenfassung für einen Text erstellt. Davinci  oder GPT-3.5-16k werden empfohlen. Hilfsmodelle hingegen werden nicht empfohlen, es sei denn, es handelt sich um ein ungefiltertes Modell mit mindestens 2000 Tokens Kontextgröße und einer ausgereiften Fähigkeiten, Texte zusammenfassen zu können.\n\nDie SupaMemory-Anweisung entscheidet darüber, welche Anweisung konkret zur Zusammenfassung gesendet werden soll. Wenn Sie das Feld leer lassen, wird die Standard-Anweisung verwendet. Es wird empfohlen, es leer zu lassen.\n\nNachdem alles eingerichtet ist, können Sie SupaMemory in den Einstellungen eines Charakters aktivieren",
        "replaceGlobalNote": "Sofern dieses Feld ausgefüllt ist, wird es die aktuelle globale Notiz ersetzen",
        "backgroundHTML": "Ein Markdown/HTML-Datenblock, der im Backend der Chat-Ausgabe hinzugefügt wird.\n\n Sie können auch zusätzliche Assets verwenden. Zum Beispiel können Sie `{{audio::<Asset-Name}}` für Hintergrundmusik verwenden.\n\n Zusätzlich können Sie dies mit weiteren Assets verwenden:\n - `{{bg::<Asset-Name>}}`: Das Hintergrundbild als Asset einfügen",
        "additionalText": "Der Text, der nur dann zur Charakterbeschreibung hinzugefügt wird, wenn die KI dies für erforderlich hält. Sie können hier lange Texte einfügen. Trennen Sie diese durch doppelte Zeilenumbrüche.",
        "charjs": "Ein Javascript-Code, der mit dem Charakter ausgeführt wird. Sie können zum Beispiel `https://github.com/kwaroran/Risuai/blob/main/src/etc/example-char.js` überprüfen. ZURZEIT AUS SICHERHEITSGRÜNDEN NICHT EMPFOHLEN. BEIM EXPORTIEREN WIRD DIES NICHT ENTHALTEN SEIN.",
        "romanizer": "Romanizer ist ein Plugin, das nicht-lateinische Zeichen in lateinische Zeichen umwandelt, um Tokens zu sparen, wenn Daten angefordert werden, die nicht-lateinische Zeichen enthalten. Dies kann zu einer anderen Ausgabe als beim ursprünglichen Modell führen. Es wird nicht empfohlen, dieses Plugin zu verwenden, wenn Sie im Chat lateinische Zeichen verwenden.",
        "inlayImages": "Wenn aktiviert, können Bilder in den Chat eingefügt werden und KIs können sie sehen, wenn sie dies unterstützen.",
        "metrica": "Metric Systemizer ist ein Plugin, das bei Anfragen metrische Einheiten in imperiale Einheiten umwandelt und umgekehrt bei der Ausgabe, um dem Benutzer das metrische System anzuzeigen, während aus Leistungsgründen imperiale Einheiten verwendet werden. Es wird nicht empfohlen, dieses Plugin zu verwenden, wenn Sie im Chat imperiale Einheiten verwenden.",
        "lorePlus": "LoreBook+ ist ein experimentelles Feature, das Vektordatenbanken anstelle von bloßem String-Abgleich verwendet, um eine bessere Erfahrung bei der Bot-Erstellung und eine bessere Abgleichleistung zu erzielen.",
        "topP": "Top P ist ein Wahrscheinlichkeitsschwellenwert für das Nucleus-Sampling. Das Modell berücksichtigt die Ergebnisse der Tokens mit top_p Wahrscheinlichkeitsmasse.",
        "openAIFixer": "OpenAI Fixer ist ein Plugin, das einige der Probleme von OpenAI behebt.",
        "sayNothing": "Wenn aktiviert, wird 'sag nichts' eingegeben, wenn keine Zeichenfolge eingegeben wurde.",
        "showUnrecommended": "Wenn aktiviert, werden nicht empfohlene, veraltete Einstellungen angezeigt. Es wird NICHT EMPFOHLEN, diese Einstellungen zu verwenden.",
        "streamingDisplayOptimizationMode": "Verringert Anzeigeruckeln, wenn lange Antworten mit viel Nachbearbeitung gestreamt werden, zum Beispiel durch regex-basierte Skripte. Das kann auf Mobilgeraeten oder leistungsschwaecherer Hardware hilfreich sein.\n\nAus behaelt das normale Verhalten bei, fuehrt die Nachbearbeitung aber bei jedem Token aus und kann dadurch deutlichen Overhead verursachen.\n\nAusgewogen senkt die Last, indem Nachbearbeitung nur in kurzen Abstaenden von etwa 0,125 Sekunden versucht wird.\n\nStark ist aehnlich wie Ausgewogen, ueberspringt die Nachbearbeitung waehrend des Streamings aber und versucht sie nur einmal nach Abschluss des Streams.\n\nDies ist eine experimentelle Funktion. Dadurch koennen einige Funktionen unbeabsichtigt anders funktionieren.",
        "imageCompression": "Wenn aktiviert, werden Bilder beim Exportieren des Charakters komprimiert. Wenn animierte Bilder nicht funktionieren, versuchen Sie, diese Option zu deaktivieren.",
        "useExperimental": "Wenn aktiviert, werden einige experimentelle Funktionen angezeigt.",
        "forceProxyAsOpenAI": "Wenn aktiviert, wird bei Verwendung eines Reverse-Proxys das OpenAI-Format erzwungen.",
        "forcePlainFetch": "Wenn aktiviert, wird die Browser-Fetch-API anstelle der nativen HTTP-Anfrage verwendet. Dies kann zu CORS-Fehlern führen.",
        "autoFillRequestURL": "Wenn aktiviert, wird die Anfrage-URL automatisch ausgefüllt, um dem aktuellen Modell zu entsprechen.",
        "chainOfThought": "Wenn aktiviert, wird der Anweisung eine 'Chain of Thought'-Anweisung hinzugefügt.",
        "gptVisionQuality": "Diese Option wird verwendet, um die Qualität des Bilderkennungsmodells festzulegen. Je höher die Qualität, desto genauer die Erkennung, aber es werden mehr Tokens verwendet.",
        "genTimes": "Diese Option wird verwendet, um die Anzahl der Antworten festzulegen, die auf Unterstützungsmodellen generiert werden sollen. Andere als die erste Antwort fungieren als zwischengespeicherter Reroll. Dies kann die Kosten des Modells senken, aber auch erhöhen, wenn Sie es ohne Reroll verwenden.",
        "requestretrys": "Diese Option wird verwendet, um die Anzahl der Anfrage-Wiederholungsversuche festzulegen, wenn eine Anfrage fehlschlägt.",
        "chatLoadInitialPages": "Anzahl der neuesten Chatnachrichten, die beim Öffnen eines Chats gerendert werden. Höhere Werte zeigen sofort mehr Verlauf, können lange Chats aber schwerer öffnen lassen.",
        "chatLoadAdditionalPages": "Anzahl älterer Chatnachrichten, die jedes Mal zusätzlich gerendert werden, wenn Sie nach oben scrollen. Höhere Werte reduzieren wiederholtes Laden, können aber jeden Ladevorgang schwerer machen.",
        "emotionPrompt": "Diese Option wird verwendet, um die Anweisung festzulegen, die zur Erkennung von Emotionen verwendet wird. Wenn sie leer ist, wird die Standardanweisung verwendet.",
        "removePunctuationHypa": "Wenn aktiviert, werden Satzzeichen entfernt, bevor HypaMemory ausgeführt wird.",
        "additionalParams": "Zusätzliche Parameter, die dem Anfrage-Body hinzugefügt werden. Wenn Sie einige Parameter ausschließen möchten, können Sie `{{none}}` als Wert eingeben. Wenn Sie einen Header anstelle eines Body hinzufügen möchten, können Sie `header::` vor den Schlüssel setzen, z. B. `header::Authorization`. Wenn Sie den Wert als JSON wünschen, können Sie `json::` vor den Wert setzen, z. B. `json::{\"key\":\"value\"}`. Andernfalls wird der Typ des Wertes automatisch bestimmt.",
        "antiClaudeOverload": "Wenn eine Claude-Überlastung auftritt, versucht Risuai, diese zu verhindern, indem es mit derselben Anweisung fortfährt, wodurch die Wahrscheinlichkeit verringert wird. Funktioniert nur für gestreamte Antworten. Dies funktioniert möglicherweise nicht für inoffizielle API-Endpunkte.",
        "triggerScript": "Trigger Script ist ein benutzerdefiniertes Skript, das ausgeführt wird, wenn eine Bedingung erfüllt ist. Es kann verwendet werden, um die Chat-Daten zu ändern, einen Befehl auszuführen, eine Variable zu ändern usw. Der Typ hängt davon ab, wann es ausgelöst wird. Es kann auch durch Schaltflächen ausgeführt werden, die mit {{button::Display::TriggerName}} oder HTML-Schaltflächen mit dem Attribut `risu-trigger=\"<TriggerName>\"` verwendet werden können.",
        "autoContinueChat": "Wenn aktiviert, wird versucht, den Chat fortzusetzen, wenn er nicht mit einem Satzzeichen endet. VERWENDEN SIE DIES NICHT BEI SPRACHEN, DIE KEINE SATZZEICHEN VERWENDEN.",
        "combineTranslation": "Wenn aktiviert, wird Text, der einen Satz bildet, aber durch HTML-Tags getrennt ist, zusammengefasst und übersetzt. Anschließend wird das Skript 'Modify Display' erneut auf die übersetzte Ausgabe angewendet.\nDies hilft dem Übersetzer, eine korrekte Übersetzung zu erstellen.\nWenn die Benutzeroberfläche bei Aktivierung dieser Option seltsam aussieht, deaktivieren Sie die Option bitte und melden Sie dies.",
        "dynamicAssets": "Wenn aktiviert, wird versucht, den ähnlichsten Asset-Namen mithilfe der Vektorsuche zu finden und durch diesen zu ersetzen, falls der Asset-Name bei der Datenverarbeitung nicht gefunden wird.",
        "dynamicAssetsEditDisplay": "Wenn aktiviert, werden dynamische Assets auch auf die Phase 'Modify Display' angewendet. Dies kann jedoch zu Leistungsproblemen führen.",
        "nickname": "Der Spitzname wird im Chat anstelle des Charakternamens in {{char}} oder <char> verwendet, falls er festgelegt ist.",
        "useRegexLorebook": "Wenn aktiviert, wird Regex anstelle von String-Abgleich für die Lorebook-Suche verwendet. Es verwendet das Format /regex/flags.",
        "customChainOfThought": "Warnung: Die Verwendung des 'Chain of Thought'-Schalters wird nicht mehr empfohlen. Fügen Sie die 'Chain of Thought'-Anweisung stattdessen in andere Anweisungseinträge ein.",
        "customPromptTemplateToggle": "Hier können Sie Ihre eigenen Anweisungsschalter definieren. Verwenden Sie das Format `<Schaltervariable>=<Schaltername>`, getrennt durch neue Zeilen. Zum Beispiel `cot=Toggle COT`. Sie können diese Schalter in der Anweisung verwenden, indem Sie `{{getglobalvar::toggle_<Schaltervariable>}}` nutzen, z. B. `{{getglobalvar::toggle_cot}}`.",
        "defaultVariables": "Hier können Sie Ihre eigenen Standardvariablen definieren. Verwenden Sie das Format `<Variablenname>=<Variablenwert>`, getrennt durch neue Zeilen. Zum Beispiel `name=Risuai`, was dann mit Trigger-Skripten und Variablen-CBS wie `{{getvar::A}}`, `{{setvar::A::B}}` oder `{{? $A + 1}}` verwendet werden kann. Wenn die Standardvariable der Anweisungsvorlage und die Standardvariable des Charakters denselben Namen haben, wird die Standardvariable des Charakters verwendet.",
        "lowLevelAccess": "Wenn aktiviert, wird der Zugriff auf Funktionen ermöglicht, die hohe Rechenleistung erfordern und KI-Modelle über Trigger im Charakter ausführen. Aktivieren Sie dies nur, wenn Sie diese Funktionen wirklich benötigen.",
        "triggerLLMPrompt": "Eine Anweisung, die an das Modell gesendet wird. Sie können mehrere Runden und Rollen verwenden, indem Sie `@@role user`, `@@role system`, `@@role assistant` nutzen. Zum Beispiel: \n```\n@@role system\nrespond as hello\n@@role assistant\nhello\n@@role user\nhi\n```",
        "legacyTranslation": "Wenn aktiviert, wird die alte Übersetzungsmethode verwendet, die Markdown und Zitate vor der Übersetzung vorverarbeitet, anstatt sie nach der Übersetzung nachzubearbeiten.",
        "luaHelp": "Sie können Lua-Skripte als Trigger-Skript verwenden. Sie können die Funktionen onInput, onOutput und onStart definieren. onInput wird aufgerufen, wenn der Benutzer eine Nachricht sendet, onOutput wird aufgerufen, wenn der Charakter eine Nachricht sendet, und onStart wird aufgerufen, wenn der Chat beginnt. Weitere Informationen finden Sie in der Dokumentation.",
        "openAIFlexProcessing": "OpenAI Flex-Antworten können langsamer sein als normale Antworten, sind aber günstiger (Batch-API-Preis). Dieser Schalter gilt nur für offizielle OpenAI Chat Completions-Anfragen.",
        "claudeCachingExperimental": "Caching in Claude ist eine experimentelle Funktion, die die Kosten des Modells senken kann, aber auch erhöhen kann, wenn Sie es ohne Reroll verwenden. Da es sich um eine experimentelle Funktion handelt, kann sie instabil sein und das Verhalten kann sich in Zukunft ändern.",
        "urllora": "Sie können einen direkten Download-Link der Modelldatei verwenden. Sie können eine direkte URL von Google Drive oder ähnlichen Websites wie https://sites.google.com/site/gdocs2direct/ erstellen oder eine Civitai-URL verwenden. Kopieren Sie die AIR (sieht aus wie `urn:air:flux1:lora:civitai:180891@776656` oder einfach `civitai:180891@776656`) und fügen Sie sie ein.",
        "v2GetAlertSelect": "Optionen werden durch das Zeichen | (Pipe) getrennt.",
        "v2RegexTest": "Gibt 1 zurück, wenn der reguläre Ausdruck übereinstimmt, und 0, wenn er nicht übereinstimmt.",
        "v2Calculate": "Wertet mathematische Ausdrücke aus und unterstützt Grundrechenarten (+, -, *, /, %, ^), Vergleichsoperatoren (<, >, <=, >=, =, !=), logische Operatoren (&&, ||, !), Klammern für die Rangfolge und Variablensubstitution im Format $VariablenName. Variablen werden automatisch in Zahlen umgewandelt (Standard ist 0, wenn ungültig).",
        "namespace": "Der Namespace ist eine eindeutige Kennung für das Modul. Er wird verwendet, um Konflikte zwischen Modulen zu vermeiden und für die Interaktion von Voreinstellungen, anderen Modulen usw. Wenn Sie nicht sicher sind, was Sie eingeben sollen, lassen Sie es leer.",
        "moduleIntergration": "Sie können Module aktivieren, indem Sie den Modul-Namespace in die Modul-Integrationsabschnitte eingeben. Wenn Sie mehrere Module aktivieren möchten, können Sie diese durch Kommas trennen. Zum Beispiel `Modul1,Modul2,Modul3`. Dies ist für fortgeschrittene Benutzer gedacht, die die Verwendung von Modulen je nach Voreinstellung variieren möchten.",
        "customCSS": "Benutzerdefiniertes CSS für das Styling. Sie können es auch deaktivieren/aktivieren, indem Sie (Strg + .) drücken, wenn etwas schief läuft.",
        "betaMobileGUI": "Wenn aktiviert, wird die Beta-Mobil-Benutzeroberfläche auf kleinen (weniger als 800px) Bildschirmen verwendet. Erfordert eine Aktualisierung.",
        "unrecommended": "Dies ist eine nicht empfohlene Einstellung. Es wird nicht empfohlen, diese Einstellung zu verwenden.",
        "jsonSchema": "Dies ist ein JSON-Schema, das an das KI-Modell gesendet wird, wenn das KI-Modell JSON-Schema unterstützt.\n\nDa das JSON-Schema jedoch schwer zu erlernen ist, können Sie in Risuai anstelle des JSON-Schemas eine Teilmenge der TypeScript-Schnittstelle verwenden. Risuai konvertiert es zur Laufzeit. Wenn Sie beispielsweise ein JSON wie dieses senden möchten:\n\n```js\n{\n  \"name\": \"Risuai\", //Name muss Risuai sein,\n  \"age\": 1, //Alter muss eine Zahl sein,\n  \"icon\": \"slim\", //Icon muss 'slim' oder 'rounded' sein\n  \"thoughts\": [\"Gute Aussicht!\", \"Lorem\"] //thoughts muss ein Array von Strings sein\n}\n```\n\nSie können diese TypeScript-Schnittstelle eingeben:\n\n```typescript\ninterface Schema {\n  name: string;\n  age: number;\n  icon: 'slim'|'rounded'\n  thoughts: string[]\n}\n```\n\nDer Name der Schnittstelle spielt keine Rolle. Weitere Informationen finden Sie in der TypeScript-Dokumentation (https://www.typescriptlang.org/docs/handbook/interfaces.html). Um zu überprüfen, welche Teilmenge von TypeScript unterstützt wird, siehe unten.<details><summary>Unterstützte TypeScript-Teilmenge</summary>\n\nUnterstützte Typen sind `boolean`, `number`, `string`, `Array`. Erweiterte Typisierung wie Einheitstypen, Schnittmengentypen, Vereinigungstypen, optional, Literaltypen usw. werden außer in diesen Fällen nicht unterstützt:\n\n        - Array von primitiven Typen: (z. B. `string[]`, `Array<boolean>)`\n        - Einheitstypen zwischen Strings: (z. B. `'slim'|'rounded'`).\n\n        Eigenschaften müssen in einer Zeile stehen. Wenn sich mehrere Eigenschaften in einer Zeile befinden, wird ein Fehler ausgegeben. Eigenschaften und Name der Schnittstelle dürfen nur lateinische Zeichen im ASCII-Bereich enthalten. Der Name der Eigenschaften darf nicht in Anführungszeichen oder doppelte Anführungszeichen gesetzt werden. Verschachtelung innerhalb der Schnittstelle wird nicht unterstützt. Es ist nicht erlaubt, `{` oder `}` in die Zeile zu setzen, in der Eigenschaften definiert sind. Wenn Sie fortgeschrittenere Typen verwenden möchten, verwenden Sie stattdessen JSON-Schema.\n        </details>",
        "strictJsonSchema": "Wenn aktiviert, wird das bereitgestellte Schema für JSON bei einigen Modellen strikt befolgt. Wenn es deaktiviert ist, wird das JSON-Schema möglicherweise ignoriert.",
        "extractJson": "Wenn es nicht leer ist, werden bestimmte JSON-Daten aus der Antwort extrahiert. Wenn Sie beispielsweise `response.text[0]` in der Antwort `{\"response\": {\"text\": [\"hallo\"]}}` extrahieren möchten, können Sie `response.text.0` eingeben.",
        "translatorNote": "Hier können Sie für jeden Charakter eine eindeutige Übersetzungsanweisung hinzufügen. Diese Option gilt nur bei Verwendung des Ax.-Modells für die Übersetzung. Fügen Sie dazu `{{slot::tnote}}` in die Spracheinstellungen ein. Es funktioniert nicht in Gruppenchats.",
        "groupInnerFormat": "Dies definiert ein Format, das im Gruppenchat für Charaktere verwendet wird, die nicht Sprecher sind. Wenn es nicht leer ist, wird dieses Format anstelle des Standardformats verwendet. Wenn `Rolle des anderen Gruppen-Bots` `assistant` ist, wird es auch auf den Sprecher angewendet.",
        "groupOtherBotRole": "Dies definiert eine Rolle, die im Gruppenchat für Charaktere verwendet wird, die nicht Sprecher sind.",
        "chatHTML": "Ein HTML, das als jeder Chat eingefügt wird.\n\nSie können CBS und spezielle Tags verwenden.\n- `<risutextbox>`: ein Textfeld, das zum Rendern von Text verwendet wird\n- `<risuicon>`: ein Symbol für Benutzer oder Assistent\n- `<risubuttons>`: Symbolschaltflächen für Chat-Bearbeitung, Übersetzungen usw.\n- `<risugeninfo>`: Schaltfläche für Generierungsinformationen.",
        "systemContentReplacement": "Das Anweisungsformat, das die Systemanweisung ersetzt, wenn das Modell keine Systemanweisung unterstützt.",
        "systemRoleReplacement": "Die Rolle, die die Systemrolle ersetzt, wenn das Modell keine Systemrolle unterstützt.",
        "summarizationPrompt": "Die Anweisung, die für die Zusammenfassung verwendet wird. Wenn sie leer ist, wird die Standardanweisung verwendet. Sie können auch ChatML-Formatierung mit {{slot}} für die Chat-Daten verwenden.",
        "translatorPrompt": "Die Anweisung, die für die Übersetzung verwendet wird. Wenn sie leer ist, wird die Standardanweisung verwendet. Sie können auch ChatML-Formatierung mit {{slot}} für die Zielsprache, {{solt::content}} für den Inhalt und {{slot::tnote}} für die Übersetzungsnotiz verwenden.",
        "translateBeforeHTMLFormatting": "Wenn aktiviert, wird der Text vor Regex-Skripten und HTML-Formatierung übersetzt. Dies könnte die Token verringern, aber die Formatierung beeinträchtigen.",
        "autoTranslateCachedOnly": "Wenn zusammen mit der Option 'Automatische Übersetzung' aktiviert, werden automatisch nur die Nachrichten übersetzt, die der Benutzer zuvor übersetzt hat.",
        "presetChain": "Wenn es nicht leer ist, wird die Voreinstellung geändert und jedes Mal zufällig angewendet, wenn der Benutzer eine Nachricht in der Voreinstellungsliste in dieser Eingabe sendet. Die Voreinstellungsliste sollte durch Kommas getrennt werden, zum Beispiel `preset1,preset2`.",
        "legacyMediaFindings": "Wenn aktiviert, wird die alte Methode zum Auffinden von Medien-Assets verwendet, ohne den zusätzlichen Suchalgorithmus zu verwenden.",
        "comfyWorkflow": "Fügen Sie den API-Workflow von Comfy UI ein. Sie können Ihren API-Workflow in Comfy UI erhalten, indem Sie die Schaltfläche 'Workflow > Export (API)' drücken. Sie müssen auch {{risu_prompt}} in Ihren Workflow-Text einfügen. Das {{risu_prompt}} wird durch die von Risu bereitgestellte Anweisung ersetzt.",
        "automaticCachePoint": "Erstellt automatisch einen Cache-Punkt nach dem Ende des Chats, wenn der Cache-Punkt nicht existiert.",
        "experimentalChatCompressionDesc": "Komprimiert die nicht verwendeten Chat-Daten und speichert sie in einer separaten Datei. Dies reduziert die Größe der Chat-Daten erheblich und verbessert die Leistung erheblich, ist jedoch experimentell und kann instabil sein, was zu Problemen bei der Backup-Funktion und mehr führen kann.",
        "promptInfoInsideChatDesc": "Wenn aktiviert, werden Informationen zur Anweisungsvoreinstellung in den Chat-Metadaten gespeichert. Die gespeicherten Daten umfassen den Namen der Voreinstellung, aktive Schalter und den Anweisungstext. Dies kann die Verarbeitungszeit und den Speicherverbrauch leicht erhöhen.",
        "autoAdjustSchema": "Wenn aktiviert, wird das JSON-Schema für die dynamische Ausgabe automatisch angepasst.",
        "dynamicMessages": "Wenn aktiviert, kann der Assistent mehrere Nachrichten hintereinander senden, anstatt nur eine nach der anderen.",
        "dynamicMemory": "Wenn aktiviert, macht der Assistent Gedächtnisnotizen zur Antwortzeit. Um diese Funktion nutzen zu können, ist eine zusätzliche Anweisung erforderlich.",
        "dynamicResponseTiming": "Wenn aktiviert, wird das Antwort-Timing dynamisch angepasst.",
        "dynamicRequest": "Wenn aktiviert, wird das Modell zu einem zufälligen Zeitpunkt angefordert, ohne auf eine Benutzereingabe zu warten.",
        "settingsCloseButtonSize": "Passt die Größe der Schließen-Schaltfläche (X) in der oberen rechten Ecke des Einstellungsfensters an. Standard ist 24.",
        "showTypingEffect": "Wenn aktiviert, wird während der Generierung einer Antwort durch den Assistenten eine Tippanzeige angezeigt.",
        "dynamicOutputPrompt": "Wenn aktiviert, werden die Schema-Informationen in die Anfrage aufgenommen.",
        "realmDirectOpen": "Wenn aktiviert, öffnet ein Klick auf einen Charakter in der RisuRealm-Vorschau direkt die Charakterbeschreibung.",
        "openRouterProviderOrder": "Die Reihenfolge der zu verwendenden Anbieter. Der erste Anbieter wird zuerst verwendet. Wenn der Anbieter nicht verfügbar ist, wird der nächste Anbieter verwendet. Siehe Details unter https://openrouter.ai/docs/guides/routing/provider-selection#ordering-specific-providers",
        "openRouterProviderOnly": "Verwenden Sie nur die Anbieter in dieser Liste. Wenn alle Anbieter nicht verfügbar sind, schlägt die Anfrage fehl. Siehe Details unter https://openrouter.ai/docs/guides/routing/provider-selection#allowing-only-specific-providers",
        "openRouterProviderIgnore": "Ignorieren Sie die Anbieter in dieser Liste. Wenn alle Anbieter ignoriert werden, schlägt die Anfrage fehl. Siehe Details unter https://openrouter.ai/docs/guides/routing/provider-selection#ignoring-providers",
        "additionalPrompt": "Text, der am Ende der Haupt-Anweisung angehängt wird, wenn die Anweisungsvorverarbeitung aktiviert ist. Der Standardwert ist 'The assistant must act as {{char}}. user is {{user}}.' Dies hilft, den grundlegenden Rollenspielkontext einzurichten.",
        "hideAllImagesDesc": "Blendet Bot-Symbole, Bot-Bild-Assets und RisuRealm-Coverbilder aus.",
        "embedding": "Das Embedding-Modell wird für die Ähnlichkeitssuche in mehreren Funktionen verwendet:\n\n- **Langzeitgedächtnis**: HypaV2, HypaV3, Hanurai Memory und SupaMemory (bei aktiviertem HypaMemory)\n- **Zusätzlicher Text**: Abgleich zusätzlicher Charakterinformationen basierend auf dem Kontext\n- **Dynamische Assets**: Finden ähnlicher Asset-Namen, wenn keine exakte Übereinstimmung gefunden wird\n- **Emotionsbilder**: Wenn die Emotionsmethode auf 'Embedding' gesetzt ist\n- **Trigger-Skripte**: Ähnlichkeitsbedingungen in Trigger-Skripten\n- **Dateianhänge**: Suche in PDF/TXT/XML-Anhängen\n- **Playground**: Embedding-Tests im Playground",
        "keepSessionAlive": "Hält den Tab aktiv und verhindert, dass die Sitzung im Browser wegen Inaktivität abläuft. Möglicherweise ist ein Neuladen erforderlich, damit die Änderung wirksam wird.\n\n- **Über Ton**: Spielt in einer Schleife einen unhörbaren tieffrequenten Ton ab, um die Sitzung aktiv zu halten. Diese Methode gilt in den meisten Browsern als am kompatibelsten und wirksamsten. Unter Android wird währenddessen eine Medienbenachrichtigung angezeigt, und andere Musik-Apps können pausiert werden.\n",
        "enableScrollToActiveChar": "Wenn aktiviert, wird durch Drücken des Hotkeys oder Halten der Strg-Taste beim Ziehen eines Charakters zum aktuell aktiven Charakter gescrollt. Geschlossene Ordner werden automatisch geöffnet."
    },
    "setup": {
        "chooseProvider": "Wählen Sie Ihren AI-Anbieter aus",
        "openaikey": "OpenAI mit API-Schlüssel (Empfohlen)",
        "openaiProxy": "OpenAI Reverse-Proxy",
        "setupmodelself": "Andere Option/Ich möchte es selbst einrichten",
        "inputApiKey": "Geben Sie Ihren API-Schlüssel hier ein",
        "apiKeyhelp": "Sie können den API-Schlüssel erhalten von: ",
        "setupSelfHelp": "Richten Sie sich nach dem Willkommensbildschirm selbst ein",
        "theme": "Wählen Sie Ihr bevorzugtes Design aus",
        "themeDescWifulike": "Für Mobilgeräte ungeeignet",
        "themeDescWifuCut": "Geeignet auch für Mobilgeräte",
        "themeDescClassic": "Geeignet für alle Geräte",
        "texttheme": "Wählen Sie Ihre Textfarbe",
        "inputName": "Geben Sie abschließend Ihren Spitznamen ein",
        "welcome": "Willkommen bei Risuai! Ich bin Airisu und werde Sie durch die Einrichtung von Risuai führen. Zuerst, wie darf ich Sie nennen?",
        "welcome2": "Hallo {username}! Bevor wir beginnen, werde ich Ihnen einige Fragen stellen. Sie können diese Einstellungen später in den Einstellungen ändern.\n\nWählen Sie zunächst den KI-Anbieter aus.",
        "openRouterProvider": "OpenRouter hat viele Modelle, einige davon ungefiltert und einige davon kostenlos, aber es ist nicht so gut wie OpenAI.",
        "hordeProvider": "Horde ist ein kostenloser Anbieter, aber die Antwortzeit ist lang und die Qualität ist gering.",
        "setProviderLater": "Es gibt andere Anbieter, aber Sie können dies später in den Einstellungen festlegen. Wählen Sie dies, wenn Sie es später einstellen möchten.",
        "setupOpenAI": "Um OpenAI nutzen zu können, benötigen Sie einen API-Schlüssel. \n1. Gehen Sie zu https://beta.openai.com/ \n2. Melden Sie sich mit Ihrem Konto an \n3. Gehen Sie zu https://beta.openai.com/account/api-keys \n4. Klicken Sie auf 'Create New API Key' und benennen Sie Ihren Schlüssel nach Belieben. \n5. Kopieren Sie den Schlüssel auf der Website.\n6. Gehen Sie zurück zu Risuai\n7. Fügen Sie ihn ein und klicken Sie auf die Senden-Schaltfläche.",
        "setupClaude": "Um Claude nutzen zu können, benötigen Sie einen API-Schlüssel.",
        "setupClaudeSteps": [
            "Gehen Sie zu dieser URL und melden Sie sich als Google an",
            "Geben Sie Ihre Informationen ein und klicken Sie auf 'Continue'",
            "Geben Sie auf der Organisationsseite einfach irgendeinen Namen nur im ersten Feld ein und klicken Sie auf 'Create Account'",
            "Drücken Sie die Schaltfläche 'Buy Credits'",
            "Drücken Sie die Schaltfläche 'Complete Setup'",
            "Geben Sie es genau wie im Bild oben ein, außer im Abschnitt Land, wo Sie Ihr Land eingeben müssen. Drücken Sie dann 'Continue'",
            "Fügen Sie Ihre Zahlungsmethode hinzu und drücken Sie 'Continue'",
            "Nachdem die Zahlung registriert wurde, drücken Sie 'Add Funds' und fügen Sie Guthaben hinzu. Sie können mindestens 5$ hinzufügen oder das automatische Aufladen einrichten.",
            "Gehen Sie nach dem Hinzufügen von Guthaben zur Dashboard-Seite und drücken Sie die Schaltfläche 'Get API Keys'",
            "Drücken Sie die Schaltfläche \"Create API Key\"",
            "Geben Sie es genau wie im Bild oben ein und drücken Sie 'Add'",
            "Kopieren Sie den Schlüssel, fügen Sie ihn hier ein und senden Sie ihn."
        ],
        "setupOpenRouter": "Um OpenRouter nutzen zu können, benötigen Sie einen API-Schlüssel. \n1. Gehen Sie zu https://openrouter.ai/keys\n2. Klicken Sie auf 'Create Key'\n3. Legen Sie einen beliebigen Schlüsselnamen fest.\n4. Kopieren Sie den Schlüssel auf der Website\n5. Gehen Sie zurück zu Risuai\n6. Fügen Sie ihn ein und klicken Sie auf die Senden-Schaltfläche.",
        "allDone": "Alles erledigt! Bitte warten Sie einen Moment.",
        "welcomeTitleName": "Wie darf ich dich nennen?",
        "welcomeTitleGuide": "Soll ich dich durch die Einrichtung führen?",
        "welcomeTitleProvider": "Wähle deinen KI-Anbieter",
        "welcomeTitleApiKey": "Füge deinen API-Schlüssel ein",
        "welcomeTitleChatLang": "Wähle eine Chat-Sprache",
        "welcomeTitleMemory": "Gedächtnis oder Kosten?",
        "welcomeTitleDone": "Alles bereit!",
        "welcomeChangeLater": "Du kannst all das später in den Einstellungen ändern.",
        "welcomeContinue": "Weiter",
        "setupLaterMessage": "Willkommen {username}! Möchten Sie, dass ich Sie durch die Einrichtung führe oder möchten Sie es selbst tun?",
        "setupMessageOption1": "Führe mich durch die Einrichtung",
        "setupMessageOption1Desc": "Empfohlen für neue Benutzer",
        "setupMessageOption2": "Ich werde es selbst einrichten",
        "claudeDesc": "Claude ist ein KI-Modell von Anthropic, einem Konkurrenten von OpenAI. Es ist besser als GPT, wenn Sie es in anderen Sprachen als Englisch verwenden möchten.",
        "openAIDesc": "OpenAI GPT ist ein qualitativ hochwertiges KI-Modell, aber es ist kostenpflichtig und gefiltert und in anderen Sprachen als Englisch schwach.",
        "chooseChatType": "Großartig! Wählen Sie nun die Chatsprache aus.",
        "chooseChatTypeOption1": "Vollständig Englisch",
        "chooseChatTypeOption1Desc": "Dadurch wird die KI Englisch verwenden und Ein-/Ausgabe erfolgt auf Englisch. Empfohlen für englischsprachige Benutzer.",
        "chooseChatTypeOption2": "Englische Verarbeitung",
        "chooseChatTypeOption2Desc": "Dadurch wird die KI intern Englisch verwenden, aber die Ein-/Ausgabe erfolgt in Ihrer Sprache. Empfohlen für nicht englischsprachige Benutzer.",
        "chooseChatTypeOption3": "Keine Sprache fokussiert",
        "chooseChatTypeOption3Desc": "Dadurch wird die KI Ihre Sprache intern verwenden, dies könnte jedoch die Qualität verringern.",
        "chooseCheapOrMemory": "Bevorzugen Sie übrigens Speicher oder Günstigkeit?",
        "chooseCheapOrMemoryOption1": "Speicher",
        "chooseCheapOrMemoryOption1Desc": "Dadurch wird sich die KI an mehr erinnern, aber es wird ziemlich teuer.",
        "chooseCheapOrMemoryOption2": "Günstig",
        "chooseCheapOrMemoryOption2Desc": "Dadurch wird sich die KI an weniger erinnern, aber es wird billiger sein.",
        "chooseCheapOrMemoryOption3": "Ausgewogen",
        "chooseCheapOrMemoryOption3Desc": "Dadurch wird sich die KI an mehr erinnern als bei Günstig, aber an weniger als bei Speicher.",
        "chooseCheapOrMemoryOption4": "Unbegrenzt",
        "chooseCheapOrMemoryOption4Desc": "Dadurch wird sich die KI an fast alles erinnern, aber es wird sehr teuer sein.",
        "finally": "Möchten Sie abschließend erweiterte Tools aktivieren?",
        "finallyOption1": "Ja",
        "finallyOption1Desc": "Dadurch werden erweiterte Tools aktiviert, aber die Benutzeroberfläche wird komplexer. Empfohlen für fortgeschrittene Benutzer.",
        "finallyOption2": "Nein",
        "finallyOption2Desc": "Dadurch werden erweiterte Tools deaktiviert und die Benutzeroberfläche vereinfacht. Empfohlen für neue Benutzer.",
        "igpPrompt": "Wenn die IGP-Anweisung nicht leer ist, wird sie nach der Hauptmodellanfrage ausgeführt, nach der Ausführung des Hauptmodells, als Emotionsmodell, und das Ergebnis wird nach der Antwort des Hauptmodells hinzugefügt."
    },
    "triggerCategories": {
        "Special": "Spezial",
        "Control": "Steuerung",
        "Chat": "Chat",
        "Low Level": "Low Level",
        "Alert": "Alarm",
        "Lorebook V2": "Lore-Buch V2",
        "String": "Zeichenkette",
        "Data": "Daten",
        "Array": "Array",
        "Others": "Andere",
        "Deprecated": "Veraltet"
    },
    "triggerDesc": {
        "v2Header": "Kopfzeile",
        "v2HeaderDesc": "Kopfzeile",
        "v2If": "Wenn",
        "v2IfDesc": "Wenn {{source}} {{condition}} {{target}}",
        "v2Else": "Sonst",
        "v2ElseDesc": "Sonst",
        "v2EndIndent": "Einzug beenden",
        "v2EndIndentDesc": "Einzug beenden",
        "v2SetVar": "Variable setzen",
        "v2SetVarDesc": "Setze Variable {{var}} {{operator}} {{value}}",
        "v2Loop": "Endlosschleife",
        "v2LoopDesc": "Endlosschleife",
        "v2BreakLoop": "Schleife abbrechen",
        "v2BreakLoopDesc": "Schleife abbrechen",
        "v2RunTrigger": "Trigger ausführen",
        "v2RunTriggerDesc": "Trigger {{target}} ausführen",
        "v2ConsoleLog": "Konsolenprotokoll",
        "v2ConsoleLogDesc": "Konsolenprotokoll {{source}}",
        "v2StopTrigger": "Trigger stoppen",
        "v2StopTriggerDesc": "Trigger stoppen",
        "v2CutChat": "Chat schneiden",
        "v2CutChatDesc": "Chat von {{start}} bis {{end}} schneiden",
        "v2ModifyChat": "Chat ändern",
        "v2ModifyChatDesc": "Chat bei Index {{index}} mit {{value}} ändern",
        "v2SystemPrompt": "Systemanweisung hinzufügen",
        "v2SystemPromptDesc": "Systemanweisung bei {{location}} mit {{value}} hinzufügen",
        "v2Impersonate": "Chat senden",
        "v2ImpersonateDesc": "Chat als {{role}} mit {{value}} senden",
        "v2Command": "Befehl ausführen",
        "v2CommandDesc": "Befehl mit {{value}} ausführen",
        "v2SendAIprompt": "KI-Anweisung senden",
        "v2SendAIpromptDesc": "KI-Anweisung senden",
        "v2ImgGen": "Bildgenerierung",
        "v2ImgGenDesc": "Bild generieren aus {{value}}, Negativ aus {{negValue}} => {{outputVar}}",
        "v2CheckSimilarity": "Ähnlichkeit prüfen",
        "v2CheckSimilarityDesc": "Ähnlichkeit zwischen {{source}} und {{value}} prüfen => {{outputVar}}",
        "v2RunLLM": "Modell ausführen",
        "v2RunLLMDesc": "Anfrage an Modell von {{value}} senden => {{outputVar}}",
        "v2ShowAlert": "Alarm anzeigen",
        "v2ShowAlertDesc": "Alarm mit {{value}} anzeigen",
        "v2ExtractRegex": "Regex extrahieren",
        "v2ExtractRegexDesc": "Text aus {{value}} mit Regex {{regexType}} {{regex}} und Flags {{flagsType}} {{flags}} extrahieren, dann Ergebnis als {{resultType}} {{result}} speichern => {{outputVar}}",
        "v2RegexTest": "Regex-Test",
        "v2RegexTestDesc": "Teste {{value}} mit Regex {{regex}} und Flags {{flags}} => {{outputVar}}",
        "v2GetLastMessage": "Letzte Nachricht abrufen",
        "v2GetLastMessageDesc": "Letzte Nachricht abrufen => {{outputVar}}",
        "v2GetMessageAtIndex": "Nachricht bei Index abrufen",
        "v2GetMessageAtIndexDesc": "Nachricht bei Index {{index}} abrufen => {{outputVar}}",
        "v2GetMessageCount": "Nachrichtenanzahl abrufen",
        "v2GetMessageCountDesc": "Nachrichtenanzahl abrufen => {{outputVar}}",
        "v2GetLorebook": "Lore-Buch abrufen",
        "v2GetLorebookDesc": "Lore-Buch namens {{target}} abrufen => {{outputVar}}",
        "v2GetLorebookCount": "Lore-Buch-Anzahl abrufen",
        "v2GetLorebookCountDesc": "Lore-Buch-Anzahl abrufen => {{outputVar}}",
        "v2GetLorebookEntry": "Lore-Buch mit Index abrufen",
        "v2GetLorebookEntryDesc": "Lore-Buch mit Index {{index}} abrufen => {{outputVar}}",
        "v2SetLorebookActivation": "Lore-Buch-Aktivierung setzen",
        "v2SetLorebookActivationDesc": "Setze Aktivierungsstatus von Lore-Buch mit Index {{index}} auf {{value}}",
        "v2GetLorebookIndexViaName": "Lore-Buch-Index über Namen abrufen",
        "v2GetLorebookIndexViaNameDesc": "Lore-Buch-Index über Namen {{name}} abrufen => {{outputVar}}",
        "v2ModifyLorebook": "Lore-Buch ändern",
        "v2ModifyLorebookDesc": "Lore-Buch namens {{target}} mit {{value}} ändern",
        "v2LoopNTimes": "N-mal schleifen",
        "v2LoopNTimesDesc": "{{value}}-mal schleifen",
        "v2Random": "Zufall",
        "v2RandomDesc": "Zufall von {{min}} bis {{max}} => {{outputVar}}",
        "v2GetCharAt": "Zeichen bei Index abrufen",
        "v2GetCharAtDesc": "Zeichen bei Index {{index}} von {{source}} abrufen => {{outputVar}}",
        "v2GetCharCount": "Zeichenanzahl abrufen",
        "v2GetCharCountDesc": "Zeichenanzahl von {{source}} abrufen => {{outputVar}}",
        "v2ToLowerCase": "In Kleinbuchstaben umwandeln",
        "v2ToLowerCaseDesc": "{{source}} in Kleinbuchstaben umwandeln => {{outputVar}}",
        "v2ToUpperCase": "In Großbuchstaben umwandeln",
        "v2ToUpperCaseDesc": "{{source}} in Großbuchstaben umwandeln => {{outputVar}}",
        "v2SetCharAt": "Zeichen bei Index setzen",
        "v2SetCharAtDesc": "Setze Zeichen bei Index {{index}} in {{source}} auf {{value}} => {{outputVar}}",
        "v2SplitString": "String teilen",
        "v2SplitStringDesc": "{{source}} durch {{delimiter}} teilen => {{outputVar}}",
        "v2GetCharacterDesc": "Charakterbeschreibung abrufen",
        "v2GetCharacterDescDesc": "Charakterbeschreibung abrufen => {{outputVar}}",
        "v2SetCharacterDesc": "Charakterbeschreibung setzen",
        "v2SetCharacterDescDesc": "Charakterbeschreibung auf {{value}} setzen",
        "v2GetPersonaDesc": "Persona-Anweisung abrufen",
        "v2GetPersonaDescDesc": "Persona-Anweisung abrufen => {{outputVar}}",
        "v2SetPersonaDesc": "Persona-Anweisung setzen",
        "v2SetPersonaDescDesc": "Persona-Anweisung auf {{value}} setzen",
        "v2GetReplaceGlobalNote": "Ersatz für globale Notiz abrufen",
        "v2GetReplaceGlobalNoteDesc": "Ersatz für globale Notiz abrufen => {{outputVar}}",
        "v2SetReplaceGlobalNote": "Ersatz für globale Notiz setzen",
        "v2SetReplaceGlobalNoteDesc": "Ersatz für globale Notiz auf {{value}} setzen",
        "v2GetAuthorNote": "Autorenanmerkung abrufen",
        "v2GetAuthorNoteDesc": "Autorenanmerkung abrufen => {{outputVar}}",
        "v2SetAuthorNote": "Autorenanmerkung setzen",
        "v2SetAuthorNoteDesc": "Autorenanmerkung auf {{value}} setzen",
        "v2Comment": "Kommentar hinzufügen",
        "v2CommentDesc": "{{value}}",
        "v2DeclareLocalVar": "Lokale Variable deklarieren",
        "v2DeclareLocalVarDesc": "Lokale Variable {{var}} mit Wert {{value}} deklarieren",
        "v2MakeArrayVar": "Array-Variable erstellen",
        "v2MakeArrayVarDesc": "Array-Variable {{var}} erstellen",
        "v2GetArrayVarLength": "Länge der Array-Variable abrufen",
        "v2GetArrayVarLengthDesc": "Länge der Array-Variable {{var}} abrufen => {{outputVar}}",
        "v2GetArrayVar": "Array-Variable abrufen",
        "v2GetArrayVarDesc": "Wert bei Index {{index}} von Array-Variable {{var}} abrufen => {{outputVar}}",
        "v2SetArrayVar": "Array-Variable setzen",
        "v2SetArrayVarDesc": "Wert bei Index {{index}} in Array-Variable {{var}} auf {{value}} setzen",
        "v2PushArrayVar": "Zu Array-Variable hinzufügen",
        "v2PushArrayVarDesc": "{{value}} zu Array-Variable {{var}} hinzufügen",
        "v2PopArrayVar": "Letzten Wert aus Array-Variable entfernen und abrufen",
        "v2PopArrayVarDesc": "Letzten Wert aus Array-Variable {{var}} entfernen => {{outputVar}}",
        "v2ShiftArrayVar": "Ersten Wert aus Array-Variable entfernen und abrufen",
        "v2ShiftArrayVarDesc": "Ersten Wert aus Array-Variable {{var}} entfernen => {{outputVar}}",
        "v2UnshiftArrayVar": "Zu Array-Variable als ersten Wert hinzufügen",
        "v2UnshiftArrayVarDesc": "{{value}} als ersten Wert der Array-Variable {{var}} hinzufügen",
        "v2SpliceArrayVar": "Zu Array-Variable an Index hinzufügen",
        "v2SpliceArrayVarDesc": "{{value}} als {{start}}-ten Wert der Array-Variable {{var}} hinzufügen",
        "v2SliceArrayVar": "Array-Variable schneiden",
        "v2SliceArrayVarDesc": "Array-Variable {{var}} von {{start}} bis {{end}} schneiden => {{outputVar}}",
        "v2GetIndexOfValueInArrayVar": "Index des Werts in Array-Variable abrufen",
        "v2GetIndexOfValueInArrayVarDesc": "Index von {{value}} in Array-Variable {{var}} abrufen => {{outputVar}}",
        "v2RemoveIndexFromArrayVar": "Index aus Array-Variable entfernen",
        "v2RemoveIndexFromArrayVarDesc": "Wert bei Index {{index}} aus Array-Variable {{var}} entfernen",
        "v2JoinArrayVar": "Array verbinden",
        "v2JoinArrayVarDesc": "Array {{var}} mit {{delimiter}} verbinden => {{outputVar}}",
        "v2MakeDictVar": "Wörterbuch-Variable erstellen",
        "v2MakeDictVarDesc": "Wörterbuch-Variable {{var}} erstellen",
        "v2GetDictVar": "Wörterbuch-Wert abrufen",
        "v2GetDictVarDesc": "Wert für Schlüssel {{key}} aus Wörterbuch {{var}} abrufen => {{outputVar}}",
        "v2SetDictVar": "Wörterbuch-Wert setzen",
        "v2SetDictVarDesc": "Wert für Schlüssel {{key}} in Wörterbuch {{var}} auf {{value}} setzen",
        "v2DeleteDictKey": "Wörterbuch-Schlüssel löschen",
        "v2DeleteDictKeyDesc": "Schlüssel {{key}} aus Wörterbuch {{var}} löschen",
        "v2HasDictKey": "Hat Wörterbuch-Schlüssel",
        "v2HasDictKeyDesc": "Prüfen, ob Wörterbuch {{var}} Schlüssel {{key}} hat => {{outputVar}}",
        "v2ClearDict": "Wörterbuch leeren",
        "v2ClearDictDesc": "Wörterbuch {{var}} leeren",
        "v2GetDictSize": "Wörterbuch-Größe abrufen",
        "v2GetDictSizeDesc": "Größe von Wörterbuch {{var}} abrufen => {{outputVar}}",
        "v2GetDictKeys": "Wörterbuch-Schlüssel abrufen",
        "v2GetDictKeysDesc": "Alle Schlüssel aus Wörterbuch {{var}} abrufen => {{outputVar}}",
        "v2GetDictValues": "Wörterbuch-Werte abrufen",
        "v2GetDictValuesDesc": "Alle Werte aus Wörterbuch {{var}} abrufen => {{outputVar}}",
        "v2ConcatString": "Strings verketten",
        "v2ConcatStringDesc": "{{source1}} und {{source2}} verketten => {{outputVar}}",
        "v2GetLastUserMessage": "Letzte Benutzernachricht abrufen",
        "v2GetLastUserMessageDesc": "Letzte Benutzernachricht abrufen => {{outputVar}}",
        "v2GetLastCharMessage": "Letzte Charakternachricht abrufen",
        "v2GetLastCharMessageDesc": "Letzte Charakternachricht abrufen => {{outputVar}}",
        "v2GetFirstMessage": "Erste Nachricht abrufen",
        "v2GetFirstMessageDesc": "Erste Nachricht abrufen => {{outputVar}}",
        "v2GetAlertInput": "Alarm-Eingabe abrufen",
        "v2GetAlertInputDesc": "Alarm-Eingabe abrufen => {{outputVar}}",
        "v2GetAlertSelect": "Alarm-Auswahl abrufen",
        "v2GetAlertSelectDesc": "Alarm-Auswahl {{display}} Optionen {{value}} abrufen => {{outputVar}}",
        "v2UnsupportedTrigger": "Nicht unterstützter Trigger",
        "v2UnsupportedTriggerDesc": "Nicht unterstützter Trigger",
        "v2GetDisplayState": "Anzeigestatus abrufen",
        "v2GetDisplayStateDesc": "Anzeigestatus abrufen => {{outputVar}}",
        "v2SetDisplayState": "Anzeigestatus setzen",
        "v2SetDisplayStateDesc": "Anzeigestatus auf {{value}} setzen",
        "v2UpdateGUI": "GUI aktualisieren",
        "v2UpdateGUIDesc": "GUI aktualisieren",
        "v2UpdateChatAt": "Chat bei Index aktualisieren",
        "v2UpdateChatAtDesc": "Chat bei {{index}} neu zeichnen",
        "v2Wait": "Warten",
        "v2WaitDesc": "{{value}} Sekunden warten",
        "v2GetRequestState": "Anfragedateninhalt abrufen",
        "v2GetRequestStateDesc": "Anfrageinhalt bei {{index}} abrufen => {{outputVar}}",
        "v2SetRequestState": "Anfragedateninhalt setzen",
        "v2SetRequestStateDesc": "Anfrageinhalt bei {{index}} auf {{value}} setzen",
        "v2GetRequestStateRole": "Anfragedatenrolle abrufen",
        "v2GetRequestStateRoleDesc": "Anfragedatenrolle bei {{index}} abrufen => {{outputVar}}",
        "v2SetRequestStateRole": "Anfragedatenrolle setzen",
        "v2SetRequestStateRoleDesc": "Anfragedatenrolle bei {{index}} auf {{value}} setzen",
        "v2GetRequestStateLength": "Anfragedatenlänge abrufen",
        "v2GetRequestStateLengthDesc": "Anfragedatenlänge abrufen => {{outputVar}}",
        "v2IfAdvanced": "Wenn",
        "v2IfAdvancedDesc": "Wenn {{source}} {{condition}} {{target}}",
        "v2QuickSearchChat": "Schnellsuche im Chat",
        "v2QuickSearchChatDesc": "Schnellsuche nach {{value}} im Chat mit Bedingung {{condition}} in Tiefe {{depth}} => {{outputVar}}",
        "v2StopPromptSending": "Senden der Anweisung stoppen",
        "v2StopPromptSendingDesc": "Senden der Anweisung stoppen",
        "v2Tokenize": "Tokenisieren",
        "v2TokenizeDesc": "{{value}} tokenisieren => {{outputVar}}",
        "v2GetAllLorebooks": "Alle Lore-Bücher abrufen",
        "v2GetAllLorebooksDesc": "Alle Lore-Buch-Anweisungen als Array abrufen => {{outputVar}}",
        "v2GetLorebookByName": "Lore-Buch-Indizes nach Namen abrufen",
        "v2GetLorebookByNameDesc": "Lore-Buch-Indizes-Array nach Namen {{name}} abrufen => {{outputVar}}",
        "v2GetLorebookByIndex": "Lore-Buch abrufen",
        "v2GetLorebookByIndexDesc": "Lore-Buch-Anweisung bei Index {{index}} abrufen => {{outputVar}}",
        "v2CreateLorebook": "Lore-Buch erstellen",
        "v2CreateLorebookDesc": "Lore-Buch mit Namen {{name}}, Schlüssel {{key}}, Inhalt {{content}} erstellen",
        "v2ModifyLorebookByIndex": "Lore-Buch ändern",
        "v2ModifyLorebookByIndexDesc": "Lore-Buch bei Index {{index}} mit Namen {{name}}, Schlüssel {{key}}, Inhalt {{content}} ändern",
        "v2DeleteLorebookByIndex": "Lore-Buch löschen",
        "v2DeleteLorebookByIndexDesc": "Lore-Buch bei Index {{index}} löschen",
        "v2GetLorebookCountNew": "Lore-Buch-Anzahl abrufen",
        "v2GetLorebookCountNewDesc": "Gesamte Lore-Buch-Anzahl abrufen => {{outputVar}}",
        "v2SetLorebookAlwaysActive": "Lore-Buch immer aktiv setzen",
        "v2SetLorebookAlwaysActiveDesc": "Lore-Buch bei Index {{index}} immer aktiv auf {{value}} setzen",
        "v2Calculate": "Berechnen",
        "v2CalculateDesc": "{{expression}} berechnen => {{outputVar}}",
        "v2ReplaceString": "String ersetzen",
        "v2ReplaceStringDesc": "{{source}} mit Regex {{regex}} durch {{replacement}} ersetzen => {{outputVar}}"
    },
    "triggerInputLabels": {
        "value": "Wert",
        "var": "Variable",
        "varName": "Variablenname",
        "outputVar": "Ausgabevariable",
        "name": "Name",
        "index": "Index",
        "source": "Quelle",
        "target": "Ziel",
        "condition": "Bedingung",
        "operator": "Operator",
        "role": "Rolle",
        "location": "Ort",
        "prompt": "Anweisung",
        "model": "Modell",
        "start": "Start",
        "end": "Ende",
        "min": "Min",
        "max": "Max",
        "delimiter": "Trennzeichen",
        "depth": "Tiefe",
        "key": "Schlüssel",
        "alertContent": "Alarminhalt",
        "options": "Optionen",
        "cmd": "Befehl",
        "regex": "Regex",
        "replacement": "Ersatz",
        "flags": "Flags",
        "negPrompt": "Negative Anweisung",
        "resultFormat": "Ergebnisformat",
        "activationKeys": "Aktivierungsschlüssel",
        "insertOrder": "Einfügereihenfolge",
        "sysStart": "Systemstart",
        "sysHistoryEnd": "Systemverlauf Ende",
        "sysPromptEnd": "Systemanweisung Ende",
        "addElse": "Sonst hinzufügen",
        "alwaysActive": "Immer aktiv",
        "trigger": "Trigger",
        "triggerOn": "Trigger ein",
        "valueTypeDesc": "Direkten Eingabewert verwenden",
        "varTypeDesc": "In Variable gespeicherten Wert verwenden",
        "conditionEqual": "Gleich (=)",
        "conditionNotEqual": "Ungleich (≠)",
        "conditionGreater": "Größer (>)",
        "conditionLess": "Kleiner (<)",
        "conditionGreaterEqual": "Größer oder Gleich (≥)",
        "conditionLessEqual": "Kleiner oder Gleich (≤)",
        "conditionSimilar": "Ähnlich (≒)",
        "conditionContains": "Enthält (∋)",
        "conditionIn": "In (∈)",
        "conditionNotContains": "Enthält nicht (∌)",
        "conditionNotIn": "Nicht in (∉)",
        "conditionTruthy": "Wahrhaftig (≡)",
        "operatorSet": "Setzen (=)",
        "operatorAdd": "Addieren (+=)",
        "operatorSubtract": "Subtrahieren (-=)",
        "operatorMultiply": "Multiplizieren (*=)",
        "operatorDivide": "Dividieren (/=)",
        "operatorModulo": "Modulo (%=)",
        "searchLoose": "Lockere Suche",
        "searchStrict": "Strenge Suche",
        "searchRegex": "Regex-Suche",
        "modelMain": "Hauptmodell",
        "modelSub": "Submodell",
        "roleUser": "Benutzer",
        "roleChar": "Charakter",
        "roleSystem": "System",
        "roleAssistant": "Assistent",
        "boolTrue": "Wahr",
        "boolFalse": "Falsch",
        "boolNull": "Null",
        "helpVarName": "Geben Sie den Namen der Variablen ein",
        "helpOutputVar": "Geben Sie den Variablennamen ein, um das Ergebnis zu speichern",
        "helpIndex": "Array- oder Nachrichtenindexnummer",
        "helpRegex": "Geben Sie das Regex-Muster ein",
        "helpFlags": "Regex-Flags",
        "helpDelimiter": "Trennzeichen zum Teilen des Strings",
        "helpActivationKeys": "Kommagetrennte Aktivierungsschlüsselwörter",
        "helpInsertOrder": "Einfügereihenfolge",
        "helpDepth": "Tiefe der zu durchsuchenden Nachrichten",
        "helpMinMax": "Min- und Max-Wertebereich",
        "helpSlot": "Verwenden Sie {{slot}}, um es unverändert zu lassen",
        "expression": "Ausdruck"
    },
    "playground": {
        "playground": "Spielwiese",
        "inlayDeleteConfirm": "Möchten Sie \"{name}\" wirklich löschen?",
        "inlayDeleteMultipleConfirm": "Möchten Sie die ausgewählten {count} Ressourcen wirklich löschen?",
        "inlayDeleteSelected": "Ausgewählte löschen",
        "inlayDeselectAll": "Alle abwählen",
        "inlayEmpty": "Keine gespeicherten Inlay-Ressourcen",
        "inlayEmptyDesc": "In Chats angehängte oder generierte Bilder, Audio und Videos werden hier angezeigt",
        "inlayExplorer": "Inlay-Ressourcen-Explorer",
        "inlaySelectAll": "Alle auswählen",
        "inlayTotalAssets": "Insgesamt {count} Ressourcen",
    },
    "confirm": "Bestätigen",
    "goback": "Zurück",
    "botSettings": "Bot-Einstellungen",
    "model": "Modell",
    "apiKey": "API-Schlüssel",
    "providerURL": "Anfragen-URL",
    "providerJSON": "Anfragen-Körper JSON",
    "mainPrompt": "Haupt-Anweisung",
    "jailbreakPrompt": "Jailbreak Anweisung",
    "globalNote": "Globale Notiz",
    "autoSuggest": "Automatische Vorschläge",
    "tokens": "Tokens",
    "maxContextSize": "Maximale Kontextgröße",
    "maxResponseSize": "Maximale Antwortgröße",
    "temperature": "Temperatur",
    "frequencyPenalty": "Häufigkeitslimitierung",
    "presensePenalty": "Auftrittslimitierung",
    "advancedSettings": "Erweitert",
    "advancedSettingsWarn": "Warnung: Bitte ändern Sie die folgenden Optionen nicht, wenn Sie nicht exakt wissen, was diese bewirken!",
    "formatingOrder": "Formatreihenfolge",
    "authorNote": "Autorennotiz",
    "firstMessage": "Erste Nachricht",
    "description": "Beschreibung",
    "note": "Hinweis",
    "jailbreakToggle": "Jailbreak umschalten",
    "charIcon": "Charaktericon",
    "characterDisplay": "Charakteranzeige",
    "viewScreen": "Zusätzlicher Charakterbildschirm",
    "none": "Keine",
    "emotionImage": "Emotionsbilder",
    "noImages": "Keine Bilder",
    "noBias": "Keine Voreingenommenheit",
    "image": "Bild",
    "name": "Name",
    "folderName": "Ordnername",
    "folderRemoveConfirm": "Dieser Ordner enthält Lorebücher. Möchten Sie ihn und alle seine Inhalte wirklich löschen?",
    "emotion": "Emotionsname",
    "value": "Wert",
    "reroll": "Regenerieren",
    "chatList": "Chatliste",
    "removeChat": "Diese Nachricht entfernen?",
    "loreBook": "Lore-Buch",
    "character": "Charakter",
    "Chat": "Chat",
    "globalLoreInfo": "Charakter spezifisches Lore-Buch gilt für alle Chats mit dem entsprechenden Charakter",
    "group": "Gruppe",
    "groupLoreInfo": "Gruppen-Lorebuch gilt für alle Chats in der Gruppe",
    "localLoreInfo": "Ein Chat Lore-Buch gilt nur für den aktuellen Chat",
    "removeConfirm": "Bestätigen Sie, dass Sie Folgendes löschen möchten: ",
    "removeConfirm2": "Bitte bestätigen Sie ein weiteres mal, dass Sie Folgendes löschen möchten: ",
    "exportConfirm": "Möchten Sie dies exportieren?",
    "insertOrder": "Einfügereihenfolge",
    "activationKeys": "Aktivierungsschlüssel",
    "activationKeysInfo": "Kommagetrennt",
    "prompt": "Anweisung",
    "loreBookDepth": "Lorebuch-Suchtiefe",
    "loreBookToken": "Lorebuch maximal Tokens",
    "chatLoadInitialPages": "Anfängliche Chat-Ladeanzahl",
    "chatLoadAdditionalPages": "Zusätzliche Chat-Ladeanzahl",
    "removeCharacter": "Charakter entfernen",
    "removeGroup": "Gruppe entfernen",
    "exportCharacter": "Charakter exportieren",
    "userSetting": "Benutzereinstellungen",
    "username": "Ihr Name",
    "userIcon": "Ihr Icon",
    "successExport": "Erfolgreich exportiert und in Ihrem Download-Verzeichnis gespeichert",
    "successImport": "Erfolgreich importiert",
    "importedCharacter": "Importierter Charakter",
    "alwaysActive": "Immer aktiv",
    "additionalPrompt": "Zusätzliche Anweisung",
    "descriptionPrefix": "Beschreibung Präfix",
    "forceReplaceUrl": "Umgekehrter Proxy",
    "emotionWarn": "Hilfsmodell wird verwendet",
    "plugin": "Plugins",
    "language": "Sprache",
    "UiLanguage": "UI-Sprache",
    "createfromScratch": "Von Grund auf neu erstellen",
    "importCharacter": "Charakter importieren",
    "translator": "Übersetzer",
    "disabled": "Deaktiviert",
    "noPluginSelected": "Modell als Plugin ausgewählt, aber kein Plugin ausgewählt",
    "text": "Text",
    "UISize": "Chat Textgröße",
    "newVersion": "Update gefunden, möchten Sie installieren?",
    "remindLaterQuestion": "Wann soll ich Sie erinnern?",
    "remindIgnore": "Ignorieren",
    "remindLater1Day": "In 1 Tag erinnern",
    "remindLater3Days": "In 3 Tagen erinnern",
    "remindLater5Days": "In 5 Tagen erinnern",
    "remindLater1Week": "In 1 Woche erinnern",
    "display": "Anzeige & Audio",
    "useCustomBackground": "Benutzerdefinierter Hintergrund",
    "translateInput": "Eingabe übersetzen",
    "autoTranslation": "Automatische Übersetzung",
    "fullscreen": "Vollbild",
    "playMessage": "Nachrichten-Ton abspielen",
    "iconSize": "Icon-Größe",
    "createGroup": "Gruppenchat erstellen",
    "groupIcon": "Gruppenicon",
    "single": "Einzel",
    "multiple": "Mehrere",
    "useCharLorebook": "Verwenden Sie Lores in Charakteren",
    "selectChar": "Charakter auswählen",
    "askLoadFirstMsg": "Sollen wir die erste Nachricht laden?",
    "theme": "Thema",
    "editOrder": "Reihenfolge bearbeiten",
    "autoMode": "Automatischer Modus",
    "submodel": "Hilfsmodell",
    "timeOutinSec": "Zeitüberschreitung (in Sekunden)",
    "emotionPrompt": "Emotions-Anweisung",
    "singleView": "Einzelansicht",
    "SpacedView": "Mehrere Charakteransicht",
    "emphasizedView": "Doppelte Charakteransicht",
    "pluginWarn": "Installieren von Plugins unbekannter Herkunft könnte Probleme verursachen oder sogar schädlichen Code enthalten",
    "pluginConfirm": "Möchten Sie dieses Plugin wirklich importieren? Importieren Sie nur Plugins aus vertrauenswürdigen Quellen.",
    "pluginContainsExternalMedia": "Dieses Plugin enthält externe Medien.",
    "pluginContainsExternalJS": "Dieses Plugin enthält externes Javascript.",
    "createGroupImg": "Gruppenicon generieren",
    "waifuWidth": "Breite des Waifu Chat-Bereichs",
    "savebackup": "Erstellen und laden Sie ein Backup auf Google hoch",
    "loadbackup": "Laden Sie Ihr Backup von Google herunter",
    "files": "Daten",
    "backupConfirm": "Möchten Sie wirklich die Sicherung speichern?",
    "backupLoadConfirm": "Möchten Sie wirklich das Backup laden? Alle Daten gehen verloren!",
    "backupLoadConfirm2": "Bitte seien Sie vorsichtig: Sind Sie wirklich sicher, dass Sie das Backup laden möchten? Alle Ihre vorigen Daten gehen dadurch verloren!",
    "pasteAuthCode": "Bitte kopieren Sie den Authentifizierungscode aus dem Popup und fügen Sie ihn hier ein:",
    "others": "Andere",
    "presets": "Voreinstellungen",
    "imageGeneration": "Bildgenerierung",
    "provider": "Dienstanbieter",
    "key": "Schlüssel",
    "noData": "Keine Daten",
    "currentImageGeneration": "Aktuelle Bildgenerierungsdaten",
    "promptPreprocess": "Die Anweisung vorverarbeiten",
    "SwipeRegenerate": "Zum Aktualisieren runter wischen",
    "instantRemove": "Löschung einer Nachricht sollte alle Folgenachrichten entfernen",
    "instantRemoveConfirm": "Möchten Sie nur eine Nachricht entfernen? Wenn Sie Nein auswählen, werden auch die darauf folgenden Nachrichten entfernt",
    "textColor": "Textfarbe",
    "classicRisu": "Klassisches Risu",
    "highcontrast": "Hoher Kontrast",
    "quickPreset": "Sie können die Voreinstellung schnell ändern mit Strg + (Index der Voreinstellung)",
    "requestretrys": "Anforderungsversuche bei Fehlschlag",
    "utilityBot": "Dienstbot",
    "ShowLog": "Anforderungsprotokolle anzeigen",
    "waifuWidth2": "Waifu Charaktergröße",
    "sayNothing": "'Nichts sagen' eingeben, wenn keine Zeichenkette eingegeben wurde",
    "regexScript": "Regex-Skript",
    "type": "Typ",
    "editInput": "Eingabe ändern",
    "editOutput": "Ausgabe ändern",
    "editProcess": "Anforderungsdaten ändern",
    "loadLatest": "Neuestes Backup laden",
    "loadOthers": "Andere Backups laden",
    "exampleMessage": "Beispielnachricht",
    "creatorNotes": "Kommentar des Erstellers",
    "systemPrompt": "System-Anweisung",
    "characterNotes": "Charakternotizen",
    "personality": "Persönlichkeit",
    "scenario": "Szenario",
    "alternateGreetings": "Alternative Begrüßungen",
    "unrecommended": "Nicht empfohlen",
    "chatNotes": "Chat-Notizen",
    "showUnrecommended": "Nicht empfohlene Einstellungen anzeigen",
    "streamingDisplayOptimizationMode": "Streaming-Anzeigeoptimierung",
    "streamingDisplayOptimizationOff": "Aus",
    "streamingDisplayOptimizationBalanced": "Ausgewogen",
    "streamingDisplayOptimizationStrong": "Stark",
    "altGreet": "Alternative erste Nachrichten",
    "scripts": "Skripte",
    "settings": "Einstellungen",
    "selective": "Selektiv",
    "SecondaryKeys": "Sekundärschlüssel",
    "useGlobalSettings": "Globale Einstellungen verwenden",
    "recursiveScanning": "Rekursives Scannen",
    "creator": "Ersteller",
    "CharVersion": "Charakterversion",
    "Speech": "Sprache",
    "ToggleSuperMemory": "SupaMemory umschalten",
    "SuperMemory": "SupaMemory",
    "useExperimental": "Experimentelle Funktionen aktivieren",
    "showMemoryLimit": "Speicherlimit anzeigen",
    "showFirstMessagePages": "Seiten der ersten Nachricht anzeigen",
    "roundIcons": "Runde Icons",
    "streaming": "Streaming",
    "chatBot": "Chat Bot",
    "otherBots": "Hilfs-KIs",
    "user": "Benutzer",
    "additionalAssets": "Zusätzliche Medien",
    "editDisplay": "Anzeige bearbeiten",
    "community": "Gemeinschaft",
    "textBackgrounds": "Benutzerdefinierte Farbe für den Textbereich",
    "textBorder": "Textkonturen",
    "textScreenRound": "Abgerundeter Textbereich",
    "textScreenBorder": "Textbildschirmränder",
    "ttsReadOnlyQuoted": "Nur Zitate vorlesen",
    "ttsStop": "TTS stoppen",
    "askRemoval": "Vor dem Löschen nochmal fragen",
    "replaceGlobalNote": "Globalnote ersetzen",
    "charLoreBook": "Charakter spezifisches Lore-Buch",
    "globalLoreBook": "Lore Buch",
    "globalRegexScript": "Regex",
    "accessibility": "Barrierefreiheit",
    "sendWithEnter": "Mit Enter senden(Umschalt + Enter beim Entpacken zu senden)",
    "fixedChatTextarea": "Unten im Chatfenster fixieren",
    "clickToEdit": "Text zum Bearbeiten anklicken",
    "setNodePassword": "Legen Sie Ihr Passwort für die Sicherheit fest",
    "inputNodePassword": "Geben Sie Ihr Passwort ein. Wenn Sie sich nicht erinnern können, entfernen Sie save/__password.txt in Ihren Serverdateien und starten Sie den Server neu",
    "simple": "Einfach",
    "advanced": "Erweitert",
    "askReRollAutoSuggestions": "Neue Generierung für automatische Vorschläge",
    "creatingSuggestions": "Erstellung von Vorschlägen...",
    "orderByOrder": "Nach bestimmter Reihenfolge sprechen",
    "removeFromGroup": "Möchten Sie {{char}} wirklich aus der Gruppe entfernen?",
    "talkness": "Gesprächigkeit",
    "active": "Aktiv",
    "loreRandomActivation": "Verwenden Sie Wahrscheinlichkeitsbedingungen",
    "activationProbability": "Wahrscheinlichkeit",
    "shareCloud": "Auf RisuRealm teilen",
    "hub": "RisuRealm",
    "tags": "Schlagwörter",
    "backgroundHTML": "Hintergrund-Einbettung",
    "copied": "Kopiert",
    "useChatCopy": "Kopiervorlage für Chatnachrichten verwenden",
    "useChatSticker": "Chatsticker verwenden",
    "useAdditionalAssetsPreview": "Vorschau für zusätzliche Medien verwenden",
    "autoTranslateInput": "Eingabe automatisch übersetzen",
    "enterMessageForTranslateToEnglish": "Nachricht eingeben, um sie ins Englische zu übersetzen",
    "recent": "Letzte",
    "downloads": "Downloads",
    "trending": "Trends",
    "imageCompression": "Bildkompression",
    "notLoggedIn": "Sie sind aktuell nicht in Ihrem Account eingeloggt",
    "googleDriveInfo": "Verbinden Sie sich mit Google Drive, um Ihre Daten zu synchronisieren",
    "googleDriveConnection": "Google Drive Verbindung",
    "googleDriveConnected": "Mit Google Drive verbunden",
    "SaveDataInAccount": "Daten im Konto speichern",
    "dataSavingInAccount": "Daten im Konto speichern",
    "logout": "Abmelden",
    "loadDataFromAccount": "Daten aus dem Konto laden",
    "saveCurrentDataToAccount": "Aktuelle Daten im Konto speichern",
    "chatAssumed": "",
    "proxyAPIKey": "Schlüssel/Passwort",
    "proxyRequestModel": "Anforderungsmodell",
    "officialWiki": "Offizielles Wiki",
    "officialWikiDesc": "Offizielles Wiki für Risuai. Schauen Sie doch gerne bei uns vorbei",
    "officialDiscord": "Offizieller Discord",
    "officialDiscordDesc": "Offizieller Discord zum Austausch über Risuai",
    "persona": "Mein Profil",
    "icon": "Symbol",
    "account": "Konto",
    "remove": "Entfernen",
    "able": "Aktiv",
    "assetWidth": "Maximale Breite der Asset-Bilder",
    "animationSpeed": "Animationsgeschwindigkeit",
    "screenshot": "Screenshot",
    "screenshotSaved": "Screenshot gespeichert",
    "createBotwithAI": "Bot mit KI erstellen",
    "changeFolderName": "Geben Sie den neuen Ordnernamen ein (leer lassen zum Abbrechen)",
    "cancel": "Abbrechen",
    "renameFolder": "Ordner umbenennen",
    "changeFolderColor": "Ordnerfarbe ändern",
    "changeFolderImage": "Ordnerbild ändern",
    "fullWordMatching": "Vollständige Wortübereinstimmung",
    "botSettingAtStart": "Bot-Menü beim Start anzeigen",
    "triggerStart": "Beim Senden eines Chats",
    "triggerInput": "Beim Ausgeben eines Benutzers",
    "triggerOutput": "Beim Ausgeben eines Charakters",
    "triggerManual": "Nur manuelle Auslösung",
    "triggerCondVar": "Wenn Variable",
    "triggerCondExists": "Wenn Text im Chat vorhanden ist",
    "triggerScript": "Auslösungsskript",
    "triggerMatchRegex": "Mit Regex übereinstimmen",
    "triggerMatchLoose": "Locker übereinstimmen",
    "triggerMatchStrict": "Streng übereinstimmen",
    "searchDepth": "Suchtiefe",
    "equal": "Gleich",
    "notEqual": "Ungleich",
    "greater": "Größer",
    "less": "Kleiner",
    "greaterEqual": "Größer oder gleich",
    "lessEqual": "Kleiner oder gleich",
    "triggerEffSysPrompt": "Eine System-Anweisung hinzufügen",
    "triggerEffSetVar": "Variable ändern",
    "triggerEffImperson": "Chat senden",
    "triggerEffCommand": "Befehl ausführen",
    "triggerEffRunTrigger": "Trigger ausführen",
    "triggerEffStop": "Senden der Anweisung stoppen",
    "triggerEffCall": "Trigger aufrufen",
    "varableName": "Variablenname",
    "role": "Rolle",
    "location": "Ort",
    "promptstart": "Start der Anweisung",
    "promptend": "Ende der Anweisung",
    "historyend": "Ende der Historie",
    "always": "Immer",
    "noEffect": "Kein Effekt",
    "invaildTriggerEffect": "Dieser Effekt funktioniert nicht für diesen Auslösungstyp",
    "operator": "Operator",
    "TriggerSetToVar": "Auf Variable setzen",
    "TriggerAddToVar": "Zur Variable hinzufügen",
    "TriggerSubToVar": "Von Variable subtrahieren",
    "TriggerMulToVar": "Mit Variable multiplizieren",
    "TriggerDivToVar": "Von Variable dividieren",
    "isNull": "ist nicht festgelegt",
    "ifChatIndex": "Wenn Chat-Index",
    "ifRandom": "Wenn zufällig",
    "ifValue": "Wenn Wert",
    "hideRealm": "RisuRealm verstecken",
    "blockRealmCreator": "Ersteller blockieren",
    "blockRealmCreatorConfirm": "Alle RisuRealm-Inhalte von {{creator}} blockieren?",
    "realmCreatorBlocked": "Inhalte dieses blockierten RisuRealm-Erstellers sind nicht verfügbar.",
    "realmCreatorBlockedSuccess": "Ersteller blockiert.",
    "manageBlockedRealmCreators": "Blockierte Ersteller verwalten",
    "blockedRealmCreators": "Blockierte RisuRealm-Ersteller",
    "noBlockedRealmCreators": "Es sind keine RisuRealm-Ersteller blockiert.",
    "unblockRealmCreator": "Blockierung aufheben",
    "hideAllImages": "Alle Bilder ausblenden",
    "popularityLevel": "{} Beliebtheit",
    "colorScheme": "Farbschema",
    "rangeStart": "Bereichsstart",
    "rangeEnd": "Bereichsende",
    "untilChatEnd": "Bis zum Chat-Ende",
    "usePromptTemplate": "Verwenden einer Anweisungs-Vorlage",
    "specialType": "Spezialtyp",
    "noSpecialType": "Kein Spezialtyp",
    "forceProxyAsOpenAI": "Proxy-Format als OpenAI erzwingen",
    "promptTemplate": "Anweisungs-Vorlage",
    "customInnerFormat": "Benutzerdefiniertes Inner-Format",
    "innerFormat": "Inner-Format",
    "HypaMemory": "HypaMemory",
    "ToggleHypaMemory": "HypaMemory umschalten",
    "resetPromptTemplateConfirm": "Möchten Sie die Anweisungsvorlage wirklich zurücksetzen?",
    "emotionMethod": "Emotionsmethode",
    "continueResponse": "Antwort fortsetzen",
    "showMenuChatList": "Menü-Chatliste anzeigen",
    "translatorLanguage": "Übersetzer-Sprache",
    "translatorType": "Übersetzer-Typ",
    "htmlTranslation": "HTML-Übersetzung",
    "deeplKey": "DeepL API-Schlüssel",
    "deeplFreeKey": "DeepL Gratis API-Schlüssel",
    "deeplXUrl": "deepLX URL",
    "deeplXToken": "deepLX Token",
    "exportPersona": "Profil exportieren",
    "importPersona": "Profil importieren",
    "export": "Exportieren",
    "import": "Importieren",
    "supporterThanks": "Dankessagung",
    "supporterThanksDesc": "Danke für Ihre Unterstützung!",
    "donatorPatreonDesc": "Standardmäßig wird es nicht in der Liste angezeigt, um die Privatsphäre zu wahren. Wenn Sie Ihren Spitznamen anzeigen möchten, gehen Sie auf die Risuai Patreon-Seite und klicken Sie auf den 'Link' Button",
    "useNamePrefix": "Einen Präfix vor dem Namen verwenden",
    "textAdventureNAI": "Als Textabenteuer ausführen",
    "appendNameNAI": "Namen an NAI anhängen",
    "customStopWords": "Benutzerdefinierte Stoppwörter",
    "defaultPrompt": "Standardanweisung",
    "additionalText": "Zusätzliche Beschreibung",
    "seed": "Seed",
    "charjs": "CharacterJS",
    "depthPrompt": "Tiefenanweisung",
    "largePortrait": "Porträt",
    "lorePlus": "LoreBook+",
    "reverseProxyOobaMode": "Ooba-Modus",
    "joinMultiUserRoom": "Mehrbenutzerraum beitreten",
    "exactTokens": "Exakte Tokens",
    "fixedTokens": "Ungefähre Tokens",
    "inlayViewScreen": "Inlay-Bildschirm",
    "imgGenPrompt": "Bildgenerierungsanweisung",
    "imgGenNegatives": "Negative Bildgenerierungsanweisung",
    "imgGenInstructions": "Bildgenerierungsanweisungen",
    "usePlainFetchWarn": "Bitte deaktivieren Sie diese Option bei Verwendung von NovelAI, da dies bei Verwendung von NovelAI zu CORS-Fehlern führen kann.",
    "translationPrompt": "Übersetzungsanweisung",
    "translationResponseSize": "Übersetzungsantwortgröße",
    "webdeeplwarn": "Diese Option wird nicht für die Verwendung mit der Webversion empfohlen, da sie CORS-Fehler verursachen kann.",
    "saveBackupLocal": "Backup lokal speichern",
    "loadBackupLocal": "Backup lokal laden",
    "topP": "Top P",
    "genTimes": "Generierungsauswahl",
    "cot": "Chain of Thoughts",
    "forcePlainFetch": "Erzwinge einfachen Abruf",
    "autoFillRequestURL": "Anfrage-URL automatisch ausfüllen",
    "newOAIHandle": "Neue OpenAI-Verarbeitung",
    "inlayImage": "Inlay-Bildfunktion",
    "nativeAutomark": "Experimentelles natives Automark",
    "assistantPrefill": "Assistenten-Vorabausfüllung",
    "postEndInnerFormat": "Post-Ende",
    "sendChatAsSystem": "Chat als System senden",
    "sendName": "Namen in Nicht-Gruppen-Chat senden",
    "utilOverride": "Dienstprogramm überschreiben",
    "template": "Vorlage",
    "chatAsOriginalOnSystem": "Als Originalrolle senden",
    "exportAsDataset": "Speicherstand als Datensatz exportieren",
    "editTranslationDisplay": "Übersetzungsanzeige bearbeiten",
    "selectModel": "Modell auswählen",
    "autoRemoveThoughtTag": "Gedanken-Tag entfernen",
    "customChainOfThought": "Benutzerdefinierte Chain of Thoughts",
    "maxThoughtTagDepth": "Maximale Gedanken-Tag-Tiefe",
    "openRouterFallback": "Fallback verwenden",
    "openRouterMiddleOut": "Middle Out verwenden",
    "openRouterProviderOrder": "Anbieter-Präferenzreihenfolge",
    "openRouterProviderOnly": "Erlaubte Anbieter",
    "openRouterProviderIgnore": "Ignorierte Anbieter",
    "openRouterSearchModel": "Modelle suchen...",
    "openRouterSortByName": "Name",
    "openRouterSortByPrice": "Preis",
    "openRouterSortByProvider": "Anbieter",
    "openRouterSortAsc": "Aufsteigend",
    "openRouterSortDesc": "Absteigend",
    "geminiApiKey": "Gemini API-Schlüssel",
    "removePunctuationHypa": "Entfernung von Satzzeichen im Speicher",
    "memoryLimitThickness": "Speicherlimit-Dicke",
    "inputCardPassword": "Kartenpasswort eingeben",
    "ccv2Desc": "Charakterkarte V2 ist ein Format, das häufig in Chatbot-Programmen verwendet wird.",
    "ccv3Desc": "Charakterkarte V3 ist ein Format der nächsten Generation, das in Chatbot-Programmen verwendet wird.",
    "realmDesc": "RisuRealm ist eine Plattform zum Teilen von Inhalten für Risuai. Sie können Ihren Charakter mit anderen Benutzern teilen.",
    "rccDesc": "Risu Refined Character Card ist ein Format mit zusätzlichen Funktionen wie Passwort, Integritätsprüfung usw.",
    "password": "Passwort",
    "license": "Lizenz",
    "licenseDesc": "Sie können eine Lizenz für die Downloader auswählen, um die Verwendung der Anweisung Ihrer Karte einzuschränken.",
    "passwordDesc": "Sie können ein Passwort festlegen, um Ihre Karte vor unbefugtem Zugriff zu schützen.",
    "largePersonaPortrait": "Persona-Porträt",
    "module": "Modul",
    "modules": "Module",
    "noModules": "Es wurden keine Module installiert.",
    "createModule": "Modul erstellen",
    "basicInfo": "Basisinfo",
    "moduleContent": "Modulinhalt",
    "confirmRemoveModuleFeature": "Möchten Sie diese Funktion wirklich entfernen? Diese Aktion kann nicht rückgängig gemacht werden.",
    "editModule": "Modul bearbeiten",
    "importModule": "Modul importieren",
    "download": "Herunterladen",
    "edit": "Bearbeiten",
    "enableGlobal": "Global aktivieren",
    "chatModulesInfo": "Sie können Module für diesen Chat aktivieren oder deaktivieren. Sie können sie auch für diesen Charakter aktivieren, indem Sie mit der rechten Maustaste auf die Aktivieren-Schaltfläche klicken oder sie lange drücken.",
    "sideMenuRerollButton": "Seitenmenü-Regenerieren-Schaltfläche",
    "persistentStorage": "Dauerhafter Speicher",
    "persistentStorageSuccess": "Speicher wurde erfolgreich dauerhaft gemacht",
    "persistentStorageFail": "Speicher ist nicht dauerhaft. Haben Sie die Anfrage abgelehnt oder wird der Browser nicht unterstützt?",
    "persistentStorageRecommended": "Dauerhafter Speicher empfohlen",
    "persistentStorageDesc": "Ihr Browser unterstützt dauerhaften Speicher. Dies wird für eine bessere Leistung und Benutzererfahrung empfohlen.",
    "enable": "Aktivieren",
    "postFile": "Datei senden",
    "requestInfoInsideChat": "Anfrageinfo im Chat anzeigen",
    "inputTokens": "Eingabe-Tokens",
    "outputTokens": "Ausgabe-Tokens",
    "tokenWarning": "Die Token-Berechnung kann ungenau sein. Es wird empfohlen, sie als Referenz zu verwenden.",
    "log": "Protokoll",
    "popularityLevelDesc": "Beliebtheit steigt mit Downloads usw. Zur Schätzung: 3,7 Beliebtheit entspricht etwa 1 Download.",
    "additionalParams": "Zusätzliche Parameter",
    "heightMode": "Höhenmodus",
    "useAdvancedEditor": "Erweiterten Editor verwenden",
    "noWaitForTranslate": "Nicht auf Übersetzung warten",
    "updateRealm": "Auf RisuRealm aktualisieren",
    "updateRealmDesc": "Sie versuchen, Ihren Charakter auf RisuRealm zu aktualisieren. Dadurch wird Ihr Charakter auf RisuRealm aktualisiert, und Sie können dies nicht rückgängig machen.",
    "antiClaudeOverload": "Anti-Claude-Überlastung",
    "activeTabChange": "Aktueller Tab ist inaktiv, da ein anderer Tab aktiv ist. Um diesen Tab zu aktivieren, klicken Sie auf OK",
    "maxSupaChunkSize": "Maximale SupaMemory-Chunk-Größe",
    "addCharacter": "Charakter hinzufügen",
    "importFromRealm": "Aus RisuRealm auswählen",
    "importFromRealmDesc": "Wählen Sie über 1000 Charaktere in RisuRealm",
    "random": "Zufällig",
    "metaData": "Metadaten",
    "autoContinueMinTokens": "Ziel-Tokens (Automatische Fortsetzung)",
    "autoContinueChat": "Anti-Unvollständige Antwort (Automatische Fortsetzung)",
    "removeIncompleteResponse": "Unvollständige Sätze entfernen",
    "tokenizer": "Tokenizer",
    "chatFormating": "Chat-Formatierung",
    "useInstructPrompt": "Anweisungs-Prompt verwenden",
    "hanuraiMemory": "HanuraiMemory",
    "textAreaSize": "Eingabebereichsgröße",
    "textAreaTextSize": "Eingabebereichs-Textgröße",
    "sideBarSize": "Seitenleistengröße",
    "embedding": "Einbettung",
    "syntax": "Syntax",
    "run": "Ausführen",
    "noMessage": "Geben Sie etwas ein, um den Chat zu starten.",
    "combineTranslation": "Übersetzung kombinieren",
    "dynamicAssets": "Dynamische Assets",
    "dynamicAssetsEditDisplay": "Dynamische Assets in Anzeige verwenden",
    "longTermMemory": "Langzeitgedächtnis",
    "grid": "Raster",
    "list": "Liste",
    "trash": "Papierkorb",
    "trashDesc": "Gelöschte Charaktere werden in den Papierkorb verschoben. Sie können sie wiederherstellen oder dauerhaft löschen. Gelöschte Charaktere werden nach 3 Tagen automatisch bereinigt.",
    "shareExport": "Teilen/Exportieren",
    "risupresetDesc": "Risupreset-Format ist ein Format, das speziell für Risuai-Voreinstellungen entwickelt wurde.",
    "risuMDesc": "RisuM-Format ist ein Format, das speziell für Risuai-Module entwickelt wurde.",
    "jsonDesc": "JSON-Format ist ein Format, das sowohl für Menschen als auch für Maschinen leicht zu lesen und zu schreiben ist.",
    "nickname": "Spitzname",
    "useRegexLorebook": "Regex verwenden",
    "customPromptTemplateToggle": "Benutzerdefinierte Schalter",
    "defaultVariables": "Standardvariablen",
    "hypaAllocatedTokens": "Zugewiesene Tokens",
    "hypaChunkSize": "Chunk-Größe",
    "hypaV2Desc": "HypaMemory V2 ist ein Langzeitgedächtnissystem, das sowohl zusammengefasste Daten als auch Vektorsuche verwendet.",
    "supaDesc": "SupaMemory ist ein Langzeitgedächtnissystem, das zusammengefasste Daten für die KI verwendet.",
    "hanuraiDesc": "HanuraiMemory ist ein Gedächtnissystem, das Vektorsuche verwendet.",
    "lowLevelAccess": "Low-Level-Zugriff",
    "resultStoredVar": "Variable zum Speichern des Ergebnisses",
    "triggerEffRunLLM": "Hauptmodell ausführen",
    "triggerEffectSendAI": "KI erneut senden",
    "triggerEffCheckSim": "Ähnlichkeit prüfen",
    "triggerEffShowAlert": "Alarm anzeigen",
    "normal": "Normal",
    "error": "Fehler",
    "input": "Eingabe",
    "select": "Auswählen",
    "options": "Optionen",
    "alertContent": "Alarminhalt",
    "lowLevelAccessConfirm": "Dieser Inhalt verwendet Low-Level-Zugriff. Das bedeutet, dass dieser Inhalt direkt auf das KI-Modell und Ihren Speicher zugreifen kann. Möchten Sie diesen Inhalt wirklich importieren?",
    "triggerLowLevelOnly": "Dieser Trigger funktioniert nur mit Low-Level-Zugriff. Um diesen Trigger zu aktivieren, aktivieren Sie den Low-Level-Zugriff in den erweiterten Einstellungen des Charakters oder Moduls.",
    "truthy": "Wahrhaftig",
    "extractRegex": "Text mit Regex extrahieren",
    "runImgGen": "Bildgenerierung ausführen",
    "cutChat": "Chat schneiden",
    "modifyChat": "Chat ändern",
    "regex": "Regex",
    "flags": "Flags",
    "resultFormat": "Ergebnisformat",
    "negPrompt": "Negative Anweisung",
    "start": "Start",
    "end": "Ende",
    "index": "Index",
    "search": "Suche",
    "goCharacterOnImport": "Nach Realm-Import zum Charakter gehen",
    "format": "Format",
    "v2Warning": "Warnung: V2-Karte wird nicht mehr unterstützt. Sie enthält möglicherweise nicht alle Daten.",
    "applyModule": "Modul anwenden",
    "successApplyModule": "Modul erfolgreich angewendet",
    "font": "Schriftart",
    "lineHeight": "Zeilenhöhe",
    "loadAutoServerBackup": "Automatisches Server-Backup laden",
    "notCharxWarn": "Dieser Charakter verwendet mehrere Assets. Es wird empfohlen, diesen Charakter im CharX-Format zu exportieren, um eine bessere Kompatibilität zu gewährleisten.",
    "noPlugins": "Keine Plugins installiert",
    "legacyTranslation": "Alte Übersetzung",
    "clipboardSuccess": "In die Zwischenablage kopiert",
    "translateContent": "Inhalt übersetzen",
    "doNotTranslate": "Nicht übersetzen",
    "includePersonaName": "Personanamen einschließen",
    "hidePersonaName": "Personanamen ausblenden",
    "triggerSwitchWarn": "Wenn Sie den Triggertyp ändern, gehen die aktuellen Trigger verloren. Möchten Sie fortfahren?",
    "codeMode": "Code",
    "blockMode": "Block",
    "helpBlock": "Hilfe",
    "hideChatIcon": "Icon-UI ausblenden",
    "loadInternalBackup": "Internes Backup laden",
    "createCopy": "Kopie erstellen",
    "bindPersona": "Persona binden",
    "chatOptions": "Chat-Optionen",
    "doYouWantToBindCurrentPersona": "Möchten Sie die aktuelle Persona an diesen Chat binden?",
    "doYouWantToUnbindCurrentPersona": "Möchten Sie die Persona von diesem Chat lösen?",
    "personaBindedSuccess": "Persona erfolgreich gebunden",
    "personaUnbindedSuccess": "Persona erfolgreich gelöst",
    "parameters": "Parameter",
    "sizeAndSpeed": "Größe und Geschwindigkeit",
    "useLegacyGUI": "Alte GUI verwenden",
    "claudeCachingExperimental": "Claude-Caching",
    "openClose": "Öffnen/Schließen",
    "hideApiKeys": "API-Schlüssel ausblenden",
    "unformatQuotes": "Zitatformatierung deaktivieren",
    "enableDevTools": "Entwicklertools aktivieren",
    "selectFile": "Datei auswählen",
    "namespace": "Namespace",
    "moduleIntergration": "Modul-Integration",
    "previewInfo": "Diese Vorschau zeigt die Anweisung vor der modellspezifischen Verarbeitung.",
    "miscTools": "Verschiedene Tools",
    "promptConvertion": "Anweisungskonvertierung",
    "convertionStep1": "Wählen Sie alle Dateien aus, die sich auf die Anweisung beziehen (Kontext, Anweisung und Sampler-JSON werden unterstützt)",
    "customCSS": "Benutzerdefiniertes CSS",
    "betaMobileGUI": "Beta-Mobil-GUI",
    "menu": "Menü",
    "connectionOpen": "Verbindung geöffnet",
    "connectionOpenInfo": "Mehrbenutzerraum ist geöffnet. Sie können den Raumcode mit anderen Benutzern teilen. Andere können dem Raum beitreten, indem sie den Code in Playground > Mehrbenutzerraum beitreten verwenden.",
    "createMultiuserRoom": "Mehrbenutzerraum erstellen",
    "connectionHost": "Sie sind der Gastgeber des Raums.",
    "connectionGuest": "Sie sind Gast im Raum.",
    "otherUserRequesting": "Ein anderer Benutzer fordert bereits an. Versuchen Sie es später erneut.",
    "jsonSchema": "JSON-Schema",
    "enableJsonSchema": "Schema aktivieren",
    "strictJsonSchema": "Striktes Schema",
    "extractJson": "JSON extrahieren",
    "reloadSession": "Neuere Version der Speicherdaten gefunden. Sitzung wird neu geladen...",
    "fixMarkdownNewline": "Markdown-Zeilenumbruch korrigieren",
    "customQuotes": "Benutzerdefinierte Zitate",
    "leadingSingleQuote": "Führendes einfaches Anführungszeichen",
    "leadingDoubleQuote": "Führendes doppeltes Anführungszeichen",
    "trailingSingleQuote": "Nachfolgendes einfaches Anführungszeichen",
    "trailingDoubleQuote": "Nachfolgendes doppeltes Anführungszeichen",
    "translatorNote": "Anmerkung des Übersetzers",
    "formatGroupInSingle": "Gruppenformat im Einzelmodus formatieren",
    "groupInnerFormat": "Inneres Format für Nicht-Sprecher",
    "groupOtherBotRole": "Nicht-Sprecher-Rolle in Gruppe",
    "defineCustomGUI": "Benutzerdefinierte GUI definieren",
    "chatHTML": "Chat-HTML",
    "logShare": "Teilen-Log-Button anzeigen",
    "preview": "Vorschau",
    "recommended": "Empfohlen",
    "newChat": "Neuer Chat",
    "predictedOutput": "Vorhergesagte Ausgabe",
    "systemContentReplacement": "Systeminhalt ersetzen",
    "systemRoleReplacement": "Systemrolle ersetzen",
    "seperateParameters": "Parameter trennen",
    "seperateParametersEnabled": "Parameter trennen aktivieren",
    "summarizationPrompt": "Zusammenfassungsanweisung",
    "reSummarizationPrompt": "Wiederholte Zusammenfassungsanweisung",
    "translatorPrompt": "Übersetzungsanweisung",
    "translateBeforeHTMLFormatting": "Vor HTML-Formatierung übersetzen",
    "retranslate": "Neu übersetzen",
    "editTranslation": "Übersetzung bearbeiten",
    "editTranslationSave": "Übersetzung speichern",
    "exportTranslationCache": "Übersetzungscache exportieren",
    "exportTranslationCacheSuccess": "Übersetzungscache erfolgreich exportiert.",
    "importTranslationCache": "Übersetzungscache importieren",
    "importTranslationCacheConfirm": "Die Einträge werden in den Übersetzungscache zusammengeführt. Vorhandene Schlüssel werden überschrieben. Fortfahren?",
    "importTranslationCacheSuccess": "{0} Übersetzungscache-Einträge importiert.",
    importTranslationCacheFailed: "{0} Einträge importiert, aber {1} Einträge konnten nicht gespeichert werden. Der Speicher ist möglicherweise voll.",
    "exportTranslationCacheEmpty": "Übersetzungscache ist leer.",
    clearTranslationCache: "Übersetzungscache leeren",
    clearTranslationCacheSuccess: "Übersetzungscache wurde geleert.",
    clearTranslationCacheConfirm: "Alle Einträge im Übersetzungscache werden gelöscht. Dies kann nicht rückgängig gemacht werden. Fortfahren?",
    "loading": "Laden",
    "autoTranslateCachedOnly": "Nur zwischengespeicherte Nachrichten automatisch übersetzen",
    "notification": "Benachrichtigung",
    "permissionDenied": "Berechtigung vom Browser oder Betriebssystem verweigert",
    "customFlags": "Benutzerdefinierte Flags",
    "enableCustomFlags": "Benutzerdefinierte Flags aktivieren",
    "googleCloudTokenization": "Google Cloud Tokenisierung",
    "presetChain": "Voreinstellungskette",
    "legacyMediaFindings": "Alte Mediensuche",
    "staticsDisclaimer": "Die Statistiken basieren auf Daten ab Juli 2024. Die Daten sind möglicherweise nicht genau.",
    "subtitles": "Untertitel",
    "subtitlesWarning1": "Sie müssen ein Modell mit Audio-/Videoeingabe verwenden, um diese Funktion zu nutzen.",
    "subtitlesWarning2": "Sie müssen ein Modell mit Streaming-Funktion verwenden, um diese Funktion zu nutzen.",
    "reset": "Zurücksetzen",
    "assetMaxDifference": "Maximale Asset-Differenz",
    "sourceLanguage": "Quellsprache",
    "destinationLanguage": "Zielsprache",
    "noWebGPU": "Ihr Browser oder Betriebssystem unterstützt WebGPU nicht. Dies wird die Leistung erheblich verlangsamen.",
    "menuSideBar": "Menü-Seitenleiste",
    "home": "Startseite",
    "showSavingIcon": "Speichersymbol anzeigen",
    "pluginVersionWarn": "Dies ist Version {{plugin_version}} des Plugins, die nicht mit dieser Version von Risuai kompatibel ist. Bitte aktualisieren Sie das Plugin auf Version {{required_version}}.",
    "imageTranslation": "Bildübersetzung",
    "banCharacterset": "Bei Zeichensatz automatisch neu generieren",
    "realmDirectOpen": "Charakter in RisuRealm direkt öffnen",
    "showPromptComparison": "Anweisungsvergleich anzeigen",
    "inlayErrorResponse": "Fehlerantwort einfügen",
    "triggerOn": "Trigger ein",
    "noConfig": "Keine Konfiguration",
    "varName": "Variablenname",
    "var": "Variable",
    "condition": "Bedingung",
    "trigger": "Trigger",
    "outputVar": "Ausgabevariable",
    "source": "Quelle",
    "cmd": "Befehl",
    "sysStart": "Systemstart",
    "sysHistoryEnd": "Systemverlauf Ende",
    "sysPromptEnd": "Systemanweisung Ende",
    "target": "Ziel",
    "addElse": "Sonst hinzufügen",
    "min": "Min",
    "max": "Max",
    "delimiter": "Trennzeichen",
    "deleteCount": "Anzahl löschen",
    "triggerEffRunAxLLM": "Hilfsmodell ausführen",
    "hypaV3Settings": {
        "descriptionLabel": "HypaMemory V3 ist ein Langzeitgedächtnissystem, das sowohl Zusammenfassung als auch Vektorsuche verwendet.",
        "supaMemoryPromptPlaceHolder": "Leer lassen für Standardeinstellung",
        "maxMemoryTokensRatioLabel": "Maximales Gedächtnis-Token-Verhältnis (Geschätzt)",
        "maxMemoryTokensRatioError": "Maximales Gedächtnis-Token-Verhältnis kann nicht berechnet werden",
        "memoryTokensRatioLabel": "Gedächtnis-Token-Verhältnis",
        "extraSummarizationRatioLabel": "Zusätzliches Zusammenfassungsverhältnis",
        "maxChatsPerSummaryLabel": "Maximale Nachrichten pro Zusammenfassung",
        "recentMemoryRatioLabel": "Verhältnis der jüngsten Erinnerungen",
        "similarMemoryRatioLabel": "Verhältnis ähnlicher Erinnerungen",
        "randomMemoryRatioLabel": "Verhältnis zufälliger Erinnerungen",
        "enableSimilarityCorrectionLabel": "Ähnlichkeitskorrektur aktivieren",
        "preserveOrphanedMemoryLabel": "Verwaiste Erinnerungen bewahren",
        "applyRegexScriptWhenRerollingLabel": "Regex-Skript beim Neugenerieren anwenden",
        "doNotSummarizeUserMessageLabel": "Benutzernachrichten nicht zusammenfassen"
    },
    "hypaV3Modal": {
        "titleLabel": "HypaV3",
        "resetConfirmMessage": "Diese Aktion kann nicht rückgängig gemacht werden. Möchten Sie die HypaV3-Daten zurücksetzen?",
        "resetConfirmSecondMessage": "Diese Aktion ist unwiderruflich. Möchten Sie die HypaV3-Daten wirklich zurücksetzen?",
        "convertLabel": "Noch keine Zusammenfassungen, aber Sie können HypaV2-Daten zu V3 konvertieren.",
        "convertButton": "Zu V3 konvertieren",
        "convertSuccessMessage": "HypaV2-Daten erfolgreich zu V3 konvertiert",
        "convertErrorMessage": "Konvertierung von HypaV2 zu V3 fehlgeschlagen: {0}",
        "noSummariesLabel": "Noch keine Zusammenfassungen",
        "searchPlaceholder": "Geben Sie #N, ID oder Suchanfrage ein",
        "summaryNumberLabel": "Zusammenfassung #{0}",
        "deleteThisConfirmMessage": "Diese Zusammenfassung löschen?",
        "deleteAfterConfirmMessage": "Alle Zusammenfassungen nach dieser löschen?",
        "deleteAfterConfirmSecondMessage": "Diese Aktion kann nicht rückgängig gemacht werden. Sind Sie wirklich sicher?",
        "translationLabel": "Übersetzung",
        "rerolledSummaryLabel": "Neu generierte Zusammenfassung",
        "rerolledTranslationLabel": "Übersetzung der neu generierten Zusammenfassung",
        "connectedMessageCountLabel": "Verbundene Nachrichten ({0})",
        "connectedFirstMessageLabel": "Erste Nachricht",
        "connectedMessageRoleLabel": "Nachricht von {0}",
        "connectedMessageNotFoundLabel": "Nachricht nicht gefunden",
        "connectedMessageLoadingError": "Fehler beim Laden der verbundenen Nachricht: {0}",
        "connectedMessageTranslationLabel": "Übersetzung",
        "nextSummarizationFirstMessageLabel": "Erste Nachricht",
        "nextSummarizationNoMessageIdLabel": "Keine Nachrichten-ID",
        "nextSummarizationLabel": "HypaV3 wird [{0}] zusammenfassen",
        "nextSummarizationNoMessagesFoundLabel": "WARNUNG: Keine Nachrichten gefunden",
        "nextSummarizationLoadingError": "Fehler beim Laden des nächsten Zusammenfassungsziels: {0}",
        "summarizationConditionLabel": "Hinweis: HypaV3 beginnt mit der Zusammenfassung, wenn die Eingabe-Tokens die maximale Kontextgröße überschreiten.",
        "emptySelectedFirstMessageLabel": "WARNUNG: Ausgewählte erste Nachricht ist leer",
        "unclassified": "Nicht klassifiziert",
        "reSummarize": "Neu zusammenfassen",
        "reSummarizing": "Zusammenfassung wird neu erstellt...",
        "reSummarizeResult": "Ergebnis der erneuten Zusammenfassung",
        "retry": "Wiederholen",
        "translate": "Übersetzen",
        "tag": "Tag",
        "tagManager": "Tag-Manager",
        "tagManagerTitle": "Tag-Manager - Zusammenfassung #{0}",
        "newTagName": "Neuer Tag-Name",
        "noTagsYet": "Noch keine Tags.",
        "addNewTagHint": "Fügen Sie oben einen neuen Tag hinzu.",
        "categoryManager": "Kategorien",
        "allCategories": "Alle",
        "categoryName": "Kategoriename",
        "noCategoriesYet": "Noch keine Kategorien.",
        "addNewCategoryHint": "Klicken Sie oben auf die + Schaltfläche, um eine hinzuzufügen."
    },
    "bulkEnabling": "Lorebook-Massenaktivierung",
    "showTranslationLoading": "Übersetzungsladen anzeigen",
    "showDeprecatedTriggerV1": "Veralteten Trigger V1 anzeigen",
    "showDeprecatedTriggerV2": "Veralteten Trigger V2 anzeigen",
    "triggerV1Warning": "Trigger V1 ist veraltet. Er wird möglicherweise in Zukunft entfernt.",
    "copy": "Kopieren",
    "paste": "Einfügen",
    "depth": "Tiefe",
    "returnCSSError": "CSS-Fehler zurückgeben",
    "alwaysActiveInChat": "Immer aktiv (Aktueller Chat)",
    "childLoreDesc": "Dies ist eine Kopie des Charakter-Lores, das 'Immer aktiv' bleibt, bis es entfernt oder im Original manuell deaktiviert wird.",
    "thinkingTokens": "Denk-Tokens",
    "antiServerOverload": "Anti-Server-Überlastung",
    "localActivationInGlobalLorebook": "Lokale Aktivierung im globalen Lore-Buch",
    "cachePoint": "Cache-Punkt",
    "all": "Alle",
    "showFolderNameInIcon": "Ordnernamen im Symbol anzeigen",
    "claudeCachingRetrival": "Claude-Caching-Abruf",
    "claudeCachingRetrivalDesc": "Verlängert die Cache-Zeit für Claude-Caching, indem alle 4 Minuten angefordert wird. Dies kann die Cache-Miss-Rate verringern, aber die Kosten erhöhen, wenn es nicht richtig verwendet wird.",
    "automaticCachePoint": "Automatischer Cache-Punkt",
    "experimentalChatCompression": "Experimentelle Chat-Datenverarbeitung",
    "loadingChatData": "Lade Chat-Daten",
    "outputImageModal": "Ausgabebild-Modal",
    "playMessageOnTranslateEnd": "Audio bei Übersetzungsabschluss abspielen",
    "auxModelUnderModelSettings": "Separate Hilfsmodelle in Modelleinstellungen anzeigen",
    "seperateModelsForAxModels": "Separate Modelle für Hilfsmodelle",
    "axModelsDef": "Hilfsmodell-Definition",
    "doNotChangeSeperateModels": "Separate Modelle bei Voreinstellungsänderung nicht ändern",
    "tools": "Tools",
    "action": "Aktion",
    "hotkey": "Hotkey",
    "hotkeyDesc": {
        "reroll": "Regenerieren",
        "unreroll": "Regenerieren rückgängig machen",
        "translate": "Übersetzen",
        "remove": "Entfernen",
        "edit": "Bearbeiten",
        "copy": "Kopieren",
        "send": "Senden",
        "settings": "Einstellungen",
        "home": "Startseite",
        "presets": "Schnellauswahl Voreinstellungen",
        "persona": "Schnellauswahl Persona",
        "modelSelect": "Schnellauswahl Modell",
        "toggleCSS": "CSS umschalten",
        "prevChar": "Vorheriger Charakter",
        "nextChar": "Nächster Charakter",
        "quickMenu": "Schnellmenü",
        "quickSettings": "Schnelleinstellungen",
        "toggleVoice": "Stimme umschalten",
        "toggleLog": "Log umschalten",
        "previewRequest": "Vorschau Anfrage",
        "import": "Importieren",
        "export": "Exportieren",
        "webcam": "Webcam umschalten",
        "focusInput": "Eingabe fokussieren",
        "scrollToActiveChar": "Zum aktiven Charakter scrollen"
    },
    "screenTooSmall": "Der Bildschirm ist zu klein, um die Benutzeroberfläche anzuzeigen.",
    "advancedModelSettings": "Erweiterte Modelleinstellungen",
    "fallbackModel": "Fallback-Modell",
    "fallbackWhenBlankResponse": "Fallback bei leerer Antwort",
    "doNotChangeFallbackModels": "Fallback-Modelle bei Voreinstellungsänderung nicht ändern",
    "customModels": "Benutzerdefinierte Modelle",
    "igpPrompt": "IGP-Anweisung",
    "useTokenizerCaching": "Tokenizer-Caching verwenden",
    "hypaMemoryV2Modal": "Hypa V2 Modal",
    "hypaMemoryV3Modal": "Hypa V3 Modal",
    "showMenuHypaMemoryModal": "Menü Hypa Modal anzeigen",
    "promptInfoInsideChat": "Anweisungsinformationen zum Chat hinzufügen",
    "promptTextInfoInsideChat": "Anweisungstext zum Chat hinzufügen",
    "promptInfoEmptyMessage": "Für diese Nachricht sind keine Anweisungsinformationen verfügbar.",
    "promptInfoEmptyToggle": "Derzeit sind keine benutzerdefinierten Schalter aktiv.",
    "promptInfoEmptyText": "Es wurde kein Anweisungstext gespeichert.",
    "escapeOutput": "Ausgabe maskieren",
    "openAIFlexProcessing": "OpenAI Flex-Verarbeitung",
    "claudeBatching": "Claude Batching",
    "claude1HourCaching": "Claude 1 Stunde Caching",
    "folderNameInput": "Bitte geben Sie den neuen Ordnernamen ein",
    "folderRemoveLengthError": "Um einen Ordner zu entfernen, darf er keine Einträge enthalten.",
    "personaNotePlaceholder": "Geben Sie hier eine eindeutige Kennung für diese Persona ein. Beispiel: „Jäger-Persona“",
    "mcpAccessPrompt": "{{tool}} versucht, \"{{action}}\". Möchten Sie dies zulassen?",
    "rememberToolUsage": "Tool-Nutzung merken",
    "simplifiedToolUse": "Vereinfachte Tool-Nutzung",
    "toolCalled": "Tool '{{tool}}' aufgerufen",
    "static": "Statisch",
    "dynamic": "Dynamisch",
    "assetStyle": "Asset-Stil",
    "insertAssetPrompt": "Asset-Anweisung einfügen",
    "requestLocation": "Anfrageort",
    "newImageHandlingBeta": "Neue Bildverarbeitung (Beta)",
    "settingsExported": "Einstellungen für Fehlerbericht exportiert und in die Zwischenablage kopiert.",
    "bookmarks": "Lesezeichen",
    "noBookmarks": "Keine Lesezeichen",
    "bookmarkAskNameOrDefault": "Lesezeichennamen eingeben. Wenn nichts eingegeben wird, wird er automatisch zugewiesen.",
    "bookmarkAskNameOrCancel": "Lesezeichennamen eingeben. Wenn nichts eingegeben wird, wird das Umbenennen abgebrochen.",
    "collapseAll": "Alle einklappen",
    "expandAll": "Alle ausklappen",
    "hideErrorDetails": "Fehlerdetails ausblenden",
    "showErrorDetails": "Fehlerdetails anzeigen",
    "dynamicOutput": "Dynamische Ausgabe",
    "autoAdjustSchema": "Schema automatisch anpassen",
    "dynamicMessages": "Dynamische Nachrichten",
    "dynamicMemory": "Dynamisches Gedächtnis",
    "dynamicResponseTiming": "Dynamisches Antwort-Timing",
    "showTypingEffect": "Tippeffekt anzeigen",
    "dynamicRequest": "Dynamische Anfrage",
    "dynamicOutputPrompt": "Dynamische Ausgabeanweisung",
    "settingsCloseButtonSize": "Größe der Einstellungen-Schließen-Schaltfläche",
    "translating": "Übersetze...",
    "stackTraceTranslationFailed": "Die Übersetzung des Stack-Traces ist fehlgeschlagen. Unten wird der ursprüngliche verschleierte Stack-Trace angezeigt.",
    "translate": "Code-Adresse übersetzen",
    "apply": "Anwenden",
    "add": "Hinzufügen",
    "nightlyWarning": "## Nightly Builds\n\nSie verbinden sich mit einem Nightly Build der Software. Diese Version ist zu Testzwecken gedacht und enthält höchstwahrscheinlich Fehler. **In dieser Version unterstützen wir die Lösung von Problemen nicht direkt, auch wenn Sie auf Probleme stoßen.**",
    "loginSionyw": "Mit Sionyw-Konto anmelden",
    "pluginRiskDetectedAlert": "Risuai hat Code erkannt, der schädlich sein könnte und IHREN API-SCHLÜSSEL ODER PERSÖNLICHE DATEN STEHLEN KANN. Wir empfehlen Ihnen, DIESES PLUGIN NICHT ZU INSTALLIEREN.",
    "doNotInstall": "Nicht installieren",
    "continueAnyway": "Trotzdem fortfahren",
    "pluginNoRiskButAlert": "Risuai hat keinen schädlichen Code erkannt, aber beachten Sie bitte, dass die Installation von Plugins aus nicht vertrauenswürdigen Quellen Sicherheitsrisiken bergen kann.",
    "pluginRisksInuserFriendly": {
        "eval": "Code aus Strings auswerten",
        "globalAccess": "Zugriff auf globale Variablen",
        "thisOutsideClass": "'this' außerhalb des Klassenkontexts verwenden",
        "errorInVerification": "Fehler während des Überprüfungsprozesses",
        "storageAccess": "Zugriff auf Speicher"
    },
    "pluginRisksInuserFriendlyDesc": {
        "eval": "Das Plugin versucht, Code aus Strings auszuführen. Strings können verschleiert werden, um schädlichen Code zu verbergen.",
        "globalAccess": "Das Plugin versucht, auf globale Variablen zuzugreifen, was zu unbeabsichtigten Nebenwirkungen oder Sicherheitslücken führen kann.",
        "thisOutsideClass": "Das Plugin verwendet das Schlüsselwort 'this' außerhalb des Klassenkontexts, was zu unbeabsichtigtem Verhalten oder Sicherheitsproblemen führen kann.",
        "errorInVerification": "Während des Überprüfungsprozesses des Plugins sind Fehler aufgetreten, was auf potenzielle Probleme mit seiner Funktionalität hinweist.",
        "storageAccess": "Das Plugin versucht, auf den Speicher zuzugreifen, was zu Datenlecks oder unbefugter Datenmanipulation führen kann."
    },
    "generatedByAIDisclaimer": "Dieser Inhalt wurde von einer KI generiert und kann Ungenauigkeiten oder Verzerrungen enthalten.",
    "aiGenerationWarning": "Die Inhalte werden von einer KI generiert und können Ungenauigkeiten oder Verzerrungen enthalten.",
    "loadMore": "Mehr laden",
    "bookmark": "Lesezeichen",
    "noRequestLogs": "Keine Anforderungsprotokolle verfügbar.",
    "branchedText": "Dieser Chat wurde von {} abgezweigt.",
    "duplicatePluginFoundUpdateIt": "Doppeltes Plugin gefunden. Möchten Sie das bestehende Plugin aktualisieren?",
    "pluginUpdateFoundInstallIt": "Plugin-Update gefunden. Möchten Sie das Update installieren?",
    "goToChat": "Zum Chat",
    "branch": "Zweig",
    "newMessageButtonBottomLeft": "Unten links",
    "newMessage": "Neue Nachricht",
    "newMessageButtonBottomRight": "Unten rechts",
    "newMessageButtonBottomCenter": "Unten Mitte (Standard)",
    "newMessageButtonFloatingCircle": "Schwebender Kreis (unten rechts)",
    "disableMessage": "Nachricht deaktivieren",
    "alwaysScrollToNewMessage": "Immer zu neuen Nachrichten scrollen (Scrollposition ignorieren)",
    "disableAbove": "Nachrichten für KI kürzen",
    "autoScrollToNewMessage": "Automatisch zu neuen Nachrichten scrollen",
    "newMessageButtonStyle": "Stil der Schaltfläche „Neue Nachricht“",
    "pluginDevelopMode": "Plugin-Entwicklungsmodus",
    "newMessageButtonTopBar": "Obere Leiste",
    "fetchLogConsent": "Plugin {} möchte Protokolle abrufen, was sensible Informationen offenlegen könnte. Möchten Sie dies zulassen?",
    "getFullDatabaseConsent": "Das Plugin {} möchte auf die gesamte Datenbank zugreifen, was zur Offenlegung sensibler Informationen führen kann. Möchten Sie dies zulassen?",
    "mainDomAccessConsent": "Plugin {} möchte auf das Hauptdokument zugreifen, wodurch sensible Informationen offengelegt werden könnten. Möchten Sie dies zulassen?",
    "providerPermissionDenied": "Der Benutzer hat dem Plugin den Zugriff auf den Anbieter verweigert.",
    "enableScrollToActiveChar": "Scrollen zum aktiven Charakter aktivieren",
    "newMessageButtonRightCenter": "Mitte rechts",
    "trimStartNewChat": "„Neuen Chat starten“-Nachrichten kürzen",
    "hamburgerButtonBottom": "Menüschaltfläche an den unteren Rand der Seitenleiste verschieben",
    "keepSessionAlive": "Sitzung aktiv halten",
    "keepSessionAlivePip": "Über PiP",
    "keepSessionAliveSound": "Über Ton",
    "nanoGPTLoadingAccountInfo": "Kontodaten werden geladen…",
    "nanoGPTCreditBalance": "Guthaben:",
    "nanoGPTSubscription": "Abonnement",
    "nanoGPTGraceUntil": (date: string) => `bis ${date}`,
    "nanoGPTNoActiveSubscription": "Kein aktives Abonnement.",
    "nanoGPTCancelsAtPeriodEnd": (date: string) => `Kündigung zum Periodenende (${date})`,
    "nanoGPTWeeklyTokens": (pct: string) => `Wöchentliche enthaltene Eingabe-Token — ${pct} verbraucht`,
    "nanoGPTDailyTokens": (pct: string) => `Tägliche enthaltene Eingabe-Token — ${pct} verbraucht`,
    "nanoGPTDailyImages": (pct: string) => `Tägliche enthaltene Bilder — ${pct} verbraucht`,
    "nanoGPTResets": (date: string) => `Zurücksetzung am ${date}`,
    "nanoGPTUsed": (n: string) => `${n} verbraucht`,
    "nanoGPTRemaining": (n: string) => `${n} verbleibend`,
    "nanoGPTRenews": (date: string) => `Verlängerung am: ${date}`,
    "nanoGPTCouldNotLoadAccountInfo": "Kontodaten konnten nicht geladen werden.",
    "nanoGPTWeeklyTokensLabel": "Wöchentliche Eingabe-Token",
    "nanoGPTDailyTokensLabel": "Tägliche Eingabe-Token",
    "nanoGPTDailyImagesLabel": "Tägliche Bilder",
    "nanoGPTUsedLabel": "verwendet",
    "nanoGPTRemainingLabel": "übrig",
    "nanoGPTResetsLabel": "Zurücksetzen",
    "nanoGPTRenewsLabel": "Verlängerung:",
    "nanoGPTProvider": "Anbieter",
    "nanoGPTProviderPayAsYouGoOnly": "(nur im Pay-as-you-go-Modus verfügbar)",
    "nanoGPTProviderAuto": "Automatisch",
    "nanoGPTProviderFree": "Kostenlos",
    "nanoGPTProviderInput": "Eingabe",
    "nanoGPTProviderOutput": "Ausgabe",
    "nanoGPTProviderQuantization": "Quantisierung",
    "nanoGPTProviderUndisclosed": "Nicht offengelegt",
    "nanoGPTProviderCache": "Cache",
    "nanoGPTProviderCacheSupported": "Unterstützt",
    "nanoGPTProviderCacheNotSupported": "Nicht unterstützt",
    "nanoGPTProviderCacheRead": "Cache-Lesen",
    "nanoGPTUseSubscriptionEndpoint": "Abonnement-Endpunkt & Modelle verwenden",
    "modelGridCouldNotLoad": "Modellliste konnte nicht geladen werden. Überprüfen Sie Ihren API-Schlüssel.",
    "modelGridNoModelsMatch": (q: string) => `Keine Modelle entsprechen „${q}"`,
    "modelGridContext": (n: string) => `Kontext: ${n}`,

    nanoGPTSelectFromList: "Aus der Liste auswählen",
    nanoGPTManualInput: "Manuelle Eingabe",
    nanoGPTManualModelSelect: "Manuelle Modellauswahl",
} satisfies DeepPartial<typeof import('./en').languageEnglish>;
